(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("fFzkv", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $b6861714979486b0$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "reference_toJson", function () { return $b6861714979486b0$export$b959f71adeda4ed6; });
$parcel$export(module.exports, "fromJson", function () { return $b6861714979486b0$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "reference_fromJson", function () { return $b6861714979486b0$export$c09225d5aa9e9604; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $3Wlzc = parcelRequire("3Wlzc");

var $1Gpco = parcelRequire("1Gpco");
function $b6861714979486b0$var$toJson(c) {
    return $iv6Yc._1($jVmMx.Encode.string, c);
}
var $b6861714979486b0$var$fromJson = $1Gpco.Color.fromJson;
var $b6861714979486b0$export$892596cec99bc70e = {
    toJson: $b6861714979486b0$var$toJson,
    fromJson: $b6861714979486b0$var$fromJson
};
function $b6861714979486b0$var$toJson$1(px) {
    return $iv6Yc._1($jVmMx.Encode.string, px);
}
var $b6861714979486b0$var$fromJson$1 = $1Gpco.Px.fromJson;
var $b6861714979486b0$export$f1c8ff7305c3a8b7 = {
    toJson: $b6861714979486b0$var$toJson$1,
    fromJson: $b6861714979486b0$var$fromJson$1
};
function $b6861714979486b0$var$toJson$2(fontFamily) {
    return $jVmMx.Encode.nullable(fontFamily, $jVmMx.Encode.string);
}
var $b6861714979486b0$var$fromJson$2 = $1Gpco.Font.FontFamily.fromJson;
var $b6861714979486b0$var$FontFamily = {
    toJson: $b6861714979486b0$var$toJson$2,
    fromJson: $b6861714979486b0$var$fromJson$2
};
function $b6861714979486b0$var$toJson$3(fontWeight) {
    return $jVmMx.Encode.simpleVariant([
        [
            "WeightAuto",
            /* WeightAuto */ 0
        ],
        [
            "WeightThin",
            /* WeightThin */ 1
        ],
        [
            "WeightLight",
            /* WeightLight */ 2
        ],
        [
            "WeightNormal",
            /* WeightNormal */ 3
        ],
        [
            "WeightMedium",
            /* WeightMedium */ 4
        ],
        [
            "WeightSemiBold",
            /* WeightSemiBold */ 5
        ],
        [
            "WeightBold",
            /* WeightBold */ 6
        ]
    ], fontWeight);
}
var $b6861714979486b0$var$fromJson$3 = $1Gpco.Font.FontWeight.fromJson;
var $b6861714979486b0$var$FontWeight = {
    toJson: $b6861714979486b0$var$toJson$3,
    fromJson: $b6861714979486b0$var$fromJson$3
};
function $b6861714979486b0$var$toJson$4(font) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "fontFamily",
            $b6861714979486b0$var$toJson$2(font.fontFamily)
        ],
        [
            "fontSizeScale",
            $iv6Yc._1($jVmMx.Encode.$$float, font.fontSizeScale)
        ],
        [
            "fontWeight",
            $b6861714979486b0$var$toJson$3(font.fontWeight)
        ]
    ]);
}
var $b6861714979486b0$var$fromJson$4 = $1Gpco.Font.fromJson;
var $b6861714979486b0$export$89abf52a030e56ee = {
    FontFamily: $b6861714979486b0$var$FontFamily,
    FontWeight: $b6861714979486b0$var$FontWeight,
    toJson: $b6861714979486b0$var$toJson$4,
    fromJson: $b6861714979486b0$var$fromJson$4
};
function $b6861714979486b0$var$toJson$5(art) {
    if (typeof art === "number") return $jVmMx.Encode.simpleVariant([
        [
            "NoArt",
            /* NoArt */ 0
        ]
    ], /* NoArt */ 0);
    else if (art.TAG === /* GradientArt */ 0) return $jVmMx.Encode.deccoVariantWithPayload(art._0, "GradientArt", $jVmMx.Encode.string);
    else return $jVmMx.Encode.deccoVariantWithPayload(art._0, "ImageArt", $jVmMx.Encode.string);
}
var $b6861714979486b0$var$fromJson$5 = $1Gpco.Art.fromJson;
var $b6861714979486b0$export$3be6e5a8e8158e24 = {
    toJson: $b6861714979486b0$var$toJson$5,
    fromJson: $b6861714979486b0$var$fromJson$5
};
function $b6861714979486b0$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "themeId",
            $iv6Yc._1($3Wlzc.toJson, param.themeId)
        ],
        [
            "themeName",
            $iv6Yc._1($jVmMx.Encode.string, param.themeName)
        ],
        [
            "themeCreatedAt",
            $iv6Yc._1($jVmMx.Encode.$$float, param.themeCreatedAt)
        ],
        [
            "themeUpdatedAt",
            $iv6Yc._1($jVmMx.Encode.$$float, param.themeUpdatedAt)
        ],
        [
            "primaryColor",
            $iv6Yc._1($jVmMx.Encode.string, param.primaryColor)
        ],
        [
            "secondaryColor",
            $iv6Yc._1($jVmMx.Encode.string, param.secondaryColor)
        ],
        [
            "tertiaryColor",
            $iv6Yc._1($jVmMx.Encode.string, param.tertiaryColor)
        ],
        [
            "accentColor",
            $iv6Yc._1($jVmMx.Encode.string, param.accentColor)
        ],
        [
            "backgroundColor",
            $iv6Yc._1($jVmMx.Encode.string, param.backgroundColor)
        ],
        [
            "backgroundArt",
            $b6861714979486b0$var$toJson$5(param.backgroundArt)
        ],
        [
            "placeholderColor",
            $iv6Yc._1($jVmMx.Encode.string, param.placeholderColor)
        ],
        [
            "productPromoBackgroundColor",
            $iv6Yc._1($jVmMx.Encode.string, param.productPromoBackgroundColor)
        ],
        [
            "productPromoLabelColor",
            $iv6Yc._1($jVmMx.Encode.string, param.productPromoLabelColor)
        ],
        [
            "productPriceDiscountBackgroundColor",
            $iv6Yc._1($jVmMx.Encode.string, param.productPriceDiscountBackgroundColor)
        ],
        [
            "productPriceDiscountLabelColor",
            $iv6Yc._1($jVmMx.Encode.string, param.productPriceDiscountLabelColor)
        ],
        [
            "drawerLabelColor",
            $iv6Yc._1($jVmMx.Encode.string, param.drawerLabelColor)
        ],
        [
            "drawerBackgroundColor",
            $iv6Yc._1($jVmMx.Encode.string, param.drawerBackgroundColor)
        ],
        [
            "headingFont",
            $b6861714979486b0$var$toJson$4(param.headingFont)
        ],
        [
            "bodyFont",
            $b6861714979486b0$var$toJson$4(param.bodyFont)
        ],
        [
            "buttonFont",
            $b6861714979486b0$var$toJson$4(param.buttonFont)
        ],
        [
            "roundedEdges",
            $iv6Yc._1($jVmMx.Encode.string, param.roundedEdges)
        ],
        [
            "rowGutter",
            $iv6Yc._1($jVmMx.Encode.string, param.rowGutter)
        ],
        [
            "columnGutter",
            $iv6Yc._1($jVmMx.Encode.string, param.columnGutter)
        ],
        [
            "sectionVerticalPadding",
            $iv6Yc._1($jVmMx.Encode.string, param.sectionVerticalPadding)
        ],
        [
            "sectionPaddingTop",
            $jVmMx.Encode.nullable(param.sectionPaddingTop, $b6861714979486b0$var$toJson$1)
        ],
        [
            "sectionPaddingBottom",
            $jVmMx.Encode.nullable(param.sectionPaddingBottom, $b6861714979486b0$var$toJson$1)
        ]
    ]);
}
function $b6861714979486b0$export$b959f71adeda4ed6(v) {
    if (v) return $jVmMx.Encode.deccoVariantWithPayload(v._0, "LinkedTheme", $3Wlzc.toJson);
    else return $jVmMx.Encode.simpleVariant([
        [
            "LegacyTheme",
            /* LegacyTheme */ 0
        ]
    ], /* LegacyTheme */ 0);
}
var $b6861714979486b0$export$7ae2d2a8b28a8cb8 = $1Gpco.fromJson;
var $b6861714979486b0$export$c09225d5aa9e9604 = $1Gpco.reference_fromJson;
 /* Generic-ApiTypes Not a pure module */ 
});
parcelRegister("3Wlzc", function(module, exports) {

$parcel$export(module.exports, "fromString", function () { return $2de784942e0235f6$export$3004f64547af360e; });
$parcel$export(module.exports, "toString", function () { return $2de784942e0235f6$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "fromJson", function () { return $2de784942e0235f6$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "toJson", function () { return $2de784942e0235f6$export$d5b7a8bf56ee1fe2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $2de784942e0235f6$export$fcf199705d83ca19 = $ki9MN.Make({});
var $2de784942e0235f6$export$bb5e712207166a02 = $2de784942e0235f6$export$fcf199705d83ca19.t_decode;
var $2de784942e0235f6$export$cc42ff7b6c615091 = $2de784942e0235f6$export$fcf199705d83ca19.t_encode;
var $2de784942e0235f6$export$3004f64547af360e = $2de784942e0235f6$export$fcf199705d83ca19.fromString;
var $2de784942e0235f6$export$f84e8e69fd4488a5 = $2de784942e0235f6$export$fcf199705d83ca19.toString;
var $2de784942e0235f6$export$7ae2d2a8b28a8cb8 = $2de784942e0235f6$export$fcf199705d83ca19.fromJson;
var $2de784942e0235f6$export$d5b7a8bf56ee1fe2 = $2de784942e0235f6$export$fcf199705d83ca19.toJson;
 /* ThemeId Not a pure module */ 
});
parcelRegister("ki9MN", function(module, exports) {

$parcel$export(module.exports, "Make", function () { return $ec5d14672b55392d$export$ec284e6c61e81f96; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $doJJK = parcelRequire("doJJK");
function $ec5d14672b55392d$export$ec284e6c61e81f96($star) {
    var toString = function toString(id) {
        return id;
    };
    var fromString = function fromString(id) {
        return id;
    };
    var include = $doJJK.Make({
        toJson: $AAkl8.string,
        fromJson: $79vie.string
    });
    return {
        toString: toString,
        fromString: fromString,
        toJson: $AAkl8.string,
        fromJson: $79vie.string,
        t_encode: include.t_encode,
        t_decode: include.t_decode,
        codec: include.codec
    };
}
 /* Json__Decode Not a pure module */ 
});


parcelRegister("1Gpco", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return $139d42aaf4e6920e$export$892596cec99bc70e; });
$parcel$export(module.exports, "Px", function () { return $139d42aaf4e6920e$export$f1c8ff7305c3a8b7; });
$parcel$export(module.exports, "Font", function () { return $139d42aaf4e6920e$export$89abf52a030e56ee; });
$parcel$export(module.exports, "Art", function () { return $139d42aaf4e6920e$export$3be6e5a8e8158e24; });
$parcel$export(module.exports, "fromJson", function () { return $139d42aaf4e6920e$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "reference_fromJson", function () { return $139d42aaf4e6920e$export$c09225d5aa9e9604; });
$parcel$export(module.exports, "empty", function () { return $139d42aaf4e6920e$export$6e22c362a0406a2c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $3Wlzc = parcelRequire("3Wlzc");
var $139d42aaf4e6920e$var$fromJson = $jVmMx.Decode.string;
var $139d42aaf4e6920e$export$892596cec99bc70e = {
    fromJson: $139d42aaf4e6920e$var$fromJson
};
var $139d42aaf4e6920e$var$fromJson$1 = $jVmMx.Decode.string;
var $139d42aaf4e6920e$export$f1c8ff7305c3a8b7 = {
    fromJson: $139d42aaf4e6920e$var$fromJson$1
};
var $139d42aaf4e6920e$var$fromJson$2 = $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string);
var $139d42aaf4e6920e$var$FontFamily = {
    fromJson: $139d42aaf4e6920e$var$fromJson$2
};
var $139d42aaf4e6920e$var$fromJson$3 = $jVmMx.Decode.simpleVariant([
    [
        "WeightAuto",
        /* WeightAuto */ 0
    ],
    [
        "WeightThin",
        /* WeightThin */ 1
    ],
    [
        "WeightLight",
        /* WeightLight */ 2
    ],
    [
        "WeightNormal",
        /* WeightNormal */ 3
    ],
    [
        "WeightMedium",
        /* WeightMedium */ 4
    ],
    [
        "WeightSemiBold",
        /* WeightSemiBold */ 5
    ],
    [
        "WeightBold",
        /* WeightBold */ 6
    ]
]);
var $139d42aaf4e6920e$var$FontWeight = {
    fromJson: $139d42aaf4e6920e$var$fromJson$3
};
var $139d42aaf4e6920e$var$empty = {
    fontFamily: undefined,
    fontSizeScale: 1.0,
    fontWeight: /* WeightAuto */ 0
};
var $139d42aaf4e6920e$var$fromJson$4 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(fontFamily, fontSizeScale, fontWeight) {
    return {
        fontFamily: fontFamily,
        fontSizeScale: fontSizeScale,
        fontWeight: fontWeight
    };
}), $iv6Yc._2($jVmMx.Decode.field, "fontFamily", $139d42aaf4e6920e$var$fromJson$2)), $jVmMx.Decode.fieldWithDefault("fontSizeScale", $jVmMx.Decode.$$float, 1.0)), $jVmMx.Decode.fieldWithDefault("fontWeight", $139d42aaf4e6920e$var$fromJson$3, /* WeightAuto */ 0));
var $139d42aaf4e6920e$export$89abf52a030e56ee = {
    FontFamily: $139d42aaf4e6920e$var$FontFamily,
    FontWeight: $139d42aaf4e6920e$var$FontWeight,
    empty: $139d42aaf4e6920e$var$empty,
    fromJson: $139d42aaf4e6920e$var$fromJson$4
};
var $139d42aaf4e6920e$var$fromJson$5 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.simpleVariant([
    [
        "NoArt",
        /* NoArt */ 0
    ]
]), [
    $jVmMx.Decode.deccoVariantWithPayload("GradientArt", $jVmMx.Decode.string, function(c) {
        return {
            TAG: /* GradientArt */ 0,
            _0: c
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ImageArt", $jVmMx.Decode.string, function(c) {
        return {
            TAG: /* ImageArt */ 1,
            _0: c
        };
    })
]);
var $139d42aaf4e6920e$export$3be6e5a8e8158e24 = {
    fromJson: $139d42aaf4e6920e$var$fromJson$5
};
var $139d42aaf4e6920e$export$7ae2d2a8b28a8cb8 = $iv6Yc._2($jVmMx.Decode.andThen, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(themeId, themeName, themeCreatedAt, themeUpdatedAt, primaryColor, secondaryColor, tertiaryColor, accentColor, backgroundColor, backgroundArt, placeholderColor, productPromoBackgroundColor, productPromoLabelColor, productPriceDiscountBackgroundColor, productPriceDiscountLabelColor, drawerLabelColor, drawerBackgroundColor, headingFont, bodyFont, buttonFont, roundedEdges, rowGutter, columnGutter, sectionVerticalPadding, sectionPaddingTop, sectionPaddingBottom) {
    return {
        themeId: themeId,
        themeName: themeName,
        themeCreatedAt: themeCreatedAt,
        themeUpdatedAt: themeUpdatedAt,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        tertiaryColor: tertiaryColor,
        accentColor: accentColor,
        backgroundColor: backgroundColor,
        backgroundArt: backgroundArt,
        placeholderColor: placeholderColor,
        productPromoBackgroundColor: productPromoBackgroundColor,
        productPromoLabelColor: productPromoLabelColor,
        productPriceDiscountBackgroundColor: productPriceDiscountBackgroundColor,
        productPriceDiscountLabelColor: productPriceDiscountLabelColor,
        drawerBackgroundColor: drawerBackgroundColor,
        drawerLabelColor: drawerLabelColor,
        headingFont: headingFont,
        bodyFont: bodyFont,
        buttonFont: buttonFont,
        roundedEdges: roundedEdges,
        rowGutter: rowGutter,
        columnGutter: columnGutter,
        sectionVerticalPadding: sectionVerticalPadding,
        sectionPaddingTop: sectionPaddingTop,
        sectionPaddingBottom: sectionPaddingBottom
    };
}), $iv6Yc._2($jVmMx.Decode.field, "themeId", $3Wlzc.fromJson)), $jVmMx.Decode.fieldWithDefault("themeName", $jVmMx.Decode.string, "")), $jVmMx.Decode.fieldWithDefault("themeCreatedAt", $jVmMx.Decode.$$float, 0)), $jVmMx.Decode.fieldWithDefault("themeUpdatedAt", $jVmMx.Decode.$$float, 0)), $jVmMx.Decode.fieldWithDefault("primaryColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("secondaryColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("tertiaryColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("accentColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("backgroundColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("backgroundArt", $139d42aaf4e6920e$var$fromJson$5, /* NoArt */ 0)), $jVmMx.Decode.fieldWithDefault("placeholderColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("productPromoBackgroundColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("productPromoLabelColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("productPriceDiscountBackgroundColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("productPriceDiscountLabelColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("drawerLabelColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("drawerBackgroundColor", $139d42aaf4e6920e$var$fromJson, "")), $jVmMx.Decode.fieldWithDefault("headingFont", $139d42aaf4e6920e$var$fromJson$4, $139d42aaf4e6920e$var$empty)), $jVmMx.Decode.fieldWithDefault("bodyFont", $139d42aaf4e6920e$var$fromJson$4, $139d42aaf4e6920e$var$empty)), $jVmMx.Decode.fieldWithDefault("buttonFont", $139d42aaf4e6920e$var$fromJson$4, $139d42aaf4e6920e$var$empty)), $jVmMx.Decode.fieldWithDefault("roundedEdges", $139d42aaf4e6920e$var$fromJson$1, "0px")), $jVmMx.Decode.fieldWithDefault("rowGutter", $139d42aaf4e6920e$var$fromJson$1, "45px")), $jVmMx.Decode.fieldWithDefault("columnGutter", $139d42aaf4e6920e$var$fromJson$1, "12px")), $jVmMx.Decode.fieldWithDefault("sectionVerticalPadding", $139d42aaf4e6920e$var$fromJson$1, "0px")), $jVmMx.Decode.fieldWithDefault("sectionPaddingTop", $iv6Yc._1($jVmMx.Decode.nullable, $139d42aaf4e6920e$var$fromJson$1), undefined)), $jVmMx.Decode.fieldWithDefault("sectionPaddingBottom", $iv6Yc._1($jVmMx.Decode.nullable, $139d42aaf4e6920e$var$fromJson$1), undefined)), function(result) {
    return $iv6Yc._1($jVmMx.Decode.succeed, result);
});
var $139d42aaf4e6920e$export$c09225d5aa9e9604 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.simpleVariant([
    [
        "LegacyTheme",
        /* LegacyTheme */ 0
    ]
]), [
    $jVmMx.Decode.deccoVariantWithPayload("LinkedTheme", $3Wlzc.fromJson, function(c) {
        return /* LinkedTheme */ {
            _0: c
        };
    })
]);
var $139d42aaf4e6920e$var$empty_themeId = $iv6Yc._1($3Wlzc.fromString, "empty");
var $139d42aaf4e6920e$var$empty_headingFont = {
    fontFamily: undefined,
    fontSizeScale: 1.0,
    fontWeight: /* WeightAuto */ 0
};
var $139d42aaf4e6920e$var$empty_bodyFont = {
    fontFamily: undefined,
    fontSizeScale: 1.0,
    fontWeight: /* WeightAuto */ 0
};
var $139d42aaf4e6920e$var$empty_buttonFont = {
    fontFamily: undefined,
    fontSizeScale: 1.0,
    fontWeight: /* WeightAuto */ 0
};
var $139d42aaf4e6920e$export$6e22c362a0406a2c = {
    themeId: $139d42aaf4e6920e$var$empty_themeId,
    themeName: "",
    themeCreatedAt: 0,
    themeUpdatedAt: 0,
    primaryColor: "#111827",
    secondaryColor: "#374151",
    tertiaryColor: "#6B7280",
    accentColor: "#000000",
    backgroundColor: "#ffffff",
    backgroundArt: /* NoArt */ 0,
    placeholderColor: "#F3F4F6",
    productPromoBackgroundColor: "#F3F4F6",
    productPromoLabelColor: "#111827",
    productPriceDiscountBackgroundColor: "#dc2626",
    productPriceDiscountLabelColor: "#ffffff",
    drawerBackgroundColor: "#ffffff",
    drawerLabelColor: "#111827",
    headingFont: $139d42aaf4e6920e$var$empty_headingFont,
    bodyFont: $139d42aaf4e6920e$var$empty_bodyFont,
    buttonFont: $139d42aaf4e6920e$var$empty_buttonFont,
    roundedEdges: "4px",
    rowGutter: "45px",
    columnGutter: "12px",
    sectionVerticalPadding: "0px",
    sectionPaddingTop: undefined,
    sectionPaddingBottom: undefined
};
 /* fromJson Not a pure module */ 
});


parcelRegister("dRfYk", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $a16c9d4c2cb6102f$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $a16c9d4c2cb6102f$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "toString", function () { return $a16c9d4c2cb6102f$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "fromString", function () { return $a16c9d4c2cb6102f$export$3004f64547af360e; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $a16c9d4c2cb6102f$export$46b83a6aabf254e3 = $ki9MN.Make({});
var $a16c9d4c2cb6102f$export$bb5e712207166a02 = $a16c9d4c2cb6102f$export$46b83a6aabf254e3.t_decode;
var $a16c9d4c2cb6102f$export$cc42ff7b6c615091 = $a16c9d4c2cb6102f$export$46b83a6aabf254e3.t_encode;
var $a16c9d4c2cb6102f$export$d5b7a8bf56ee1fe2 = $a16c9d4c2cb6102f$export$46b83a6aabf254e3.toJson;
var $a16c9d4c2cb6102f$export$7ae2d2a8b28a8cb8 = $a16c9d4c2cb6102f$export$46b83a6aabf254e3.fromJson;
var $a16c9d4c2cb6102f$export$f84e8e69fd4488a5 = $a16c9d4c2cb6102f$export$46b83a6aabf254e3.toString;
var $a16c9d4c2cb6102f$export$3004f64547af360e = $a16c9d4c2cb6102f$export$46b83a6aabf254e3.fromString;
 /* Id Not a pure module */ 
});

parcelRegister("crJlr", function(module, exports) {

$parcel$export(module.exports, "fromJson", function () { return $90fb2e32b228b062$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "Button", function () { return $90fb2e32b228b062$export$353f5b6fc5456de1; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $dRfYk = parcelRequire("dRfYk");
function $90fb2e32b228b062$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($dRfYk.toJson, param.id)
        ],
        [
            "name",
            $iv6Yc._1($jVmMx.Encode.string, param.name)
        ],
        [
            "onClickFn",
            $jVmMx.Encode.nullable(param.onClickFn, $jVmMx.Encode.string)
        ],
        [
            "renderFn",
            $jVmMx.Encode.nullable(param.renderFn, $jVmMx.Encode.string)
        ],
        [
            "addToCart",
            $iv6Yc._1($jVmMx.Encode.bool, param.addToCart)
        ]
    ]);
}
var $90fb2e32b228b062$export$7ae2d2a8b28a8cb8 = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "id", $dRfYk.fromJson), $iv6Yc._2($jVmMx.Decode.field, "name", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "onClickFn", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "renderFn", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "addToCart", $jVmMx.Decode.bool), function(id, name, onClickFn, renderFn, addToCart) {
    return {
        id: id,
        name: name,
        onClickFn: onClickFn,
        renderFn: renderFn,
        addToCart: addToCart
    };
});
var $90fb2e32b228b062$var$include = $doJJK.Make({
    toJson: $90fb2e32b228b062$export$d5b7a8bf56ee1fe2,
    fromJson: $90fb2e32b228b062$export$7ae2d2a8b28a8cb8
});
function $90fb2e32b228b062$var$toJson$1(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $jVmMx.Encode.nullable(param.id, $dRfYk.toJson)
        ],
        [
            "textColor",
            $jVmMx.Encode.nullable(param.textColor, $jVmMx.Encode.string)
        ],
        [
            "bgColor",
            $jVmMx.Encode.nullable(param.bgColor, $jVmMx.Encode.string)
        ],
        [
            "label",
            $jVmMx.Encode.nullable(param.label, $jVmMx.Encode.string)
        ],
        [
            "confirmation",
            $jVmMx.Encode.nullable(param.confirmation, $jVmMx.Encode.string)
        ]
    ]);
}
var $90fb2e32b228b062$var$fromJson$1 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(id, textColor, bgColor, label, confirmation) {
    return {
        id: id,
        textColor: textColor,
        bgColor: bgColor,
        label: label,
        confirmation: confirmation
    };
}), $iv6Yc._2($jVmMx.Decode.field, "id", $iv6Yc._1($jVmMx.Decode.option, $dRfYk.fromJson))), $jVmMx.Decode.fieldWithDefault("textColor", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("bgColor", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("label", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("confirmation", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined));
var $90fb2e32b228b062$var$include$1 = $doJJK.Make({
    toJson: $90fb2e32b228b062$var$toJson$1,
    fromJson: $90fb2e32b228b062$var$fromJson$1
});
var $90fb2e32b228b062$var$Button_defaults = {
    id: undefined,
    textColor: "#ffffff",
    bgColor: "#000000",
    label: "Add to Cart",
    confirmation: "Added to cart!"
};
var $90fb2e32b228b062$var$Button_t_encode = $90fb2e32b228b062$var$include$1.t_encode;
var $90fb2e32b228b062$var$Button_t_decode = $90fb2e32b228b062$var$include$1.t_decode;
var $90fb2e32b228b062$var$Button_codec = $90fb2e32b228b062$var$include$1.codec;
var $90fb2e32b228b062$export$353f5b6fc5456de1 = {
    toJson: $90fb2e32b228b062$var$toJson$1,
    fromJson: $90fb2e32b228b062$var$fromJson$1,
    defaults: $90fb2e32b228b062$var$Button_defaults,
    t_encode: $90fb2e32b228b062$var$Button_t_encode,
    t_decode: $90fb2e32b228b062$var$Button_t_decode,
    codec: $90fb2e32b228b062$var$Button_codec
};
var $90fb2e32b228b062$export$cc42ff7b6c615091 = $90fb2e32b228b062$var$include.t_encode;
var $90fb2e32b228b062$export$bb5e712207166a02 = $90fb2e32b228b062$var$include.t_decode;
var $90fb2e32b228b062$export$1c37c01eba8ed446 = $90fb2e32b228b062$var$include.codec;
 /* fromJson Not a pure module */ 
});

parcelRegister("3u0dF", function(module, exports) {

$parcel$export(module.exports, "Overrides", function () { return $2894580601046fed$export$23b9aa6bc8814b5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $2894580601046fed$var$propertyToJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "property",
            $iv6Yc._1($jVmMx.Encode.string, param.property)
        ],
        [
            "value",
            param.value
        ]
    ]);
}
function $2894580601046fed$var$overrideToJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "configId",
            $iv6Yc._1($jVmMx.Encode.string, param.configId)
        ],
        [
            "properties",
            $iv6Yc._2($jVmMx.Encode.array, param.properties, $2894580601046fed$var$propertyToJson)
        ]
    ]);
}
function $2894580601046fed$var$toJson(__x) {
    return $iv6Yc._2($jVmMx.Encode.array, __x, $2894580601046fed$var$overrideToJson);
}
var $2894580601046fed$var$Encode = {
    propertyToJson: $2894580601046fed$var$propertyToJson,
    overrideToJson: $2894580601046fed$var$overrideToJson,
    toJson: $2894580601046fed$var$toJson
};
var $2894580601046fed$var$propertyFromJson = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(property, value) {
    return {
        property: property,
        value: value
    };
}), $iv6Yc._2($jVmMx.Decode.field, "property", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "value", $jVmMx.Decode.value));
var $2894580601046fed$var$overrideFromJson = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(configId, properties) {
    return {
        configId: configId,
        properties: properties
    };
}), $iv6Yc._2($jVmMx.Decode.field, "configId", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "properties", $iv6Yc._1($jVmMx.Decode.array, $2894580601046fed$var$propertyFromJson)));
var $2894580601046fed$var$fromJson = $iv6Yc._1($jVmMx.Decode.array, $2894580601046fed$var$overrideFromJson);
var $2894580601046fed$var$Decode = {
    propertyFromJson: $2894580601046fed$var$propertyFromJson,
    overrideFromJson: $2894580601046fed$var$overrideFromJson,
    fromJson: $2894580601046fed$var$fromJson
};
var $2894580601046fed$var$include = $doJJK.Make({
    toJson: $2894580601046fed$var$toJson,
    fromJson: $2894580601046fed$var$fromJson
});
function $2894580601046fed$var$getByConfigId(overrides, configId) {
    return $i7mYY.getBy(overrides, function(override) {
        return override.configId === configId;
    });
}
function $2894580601046fed$var$getByConfigIdAndProperty(overrides, configId, property) {
    return $i7mYY.getBy($2whNH.mapWithDefault($2894580601046fed$var$getByConfigId(overrides, configId), [], function(override) {
        return override.properties;
    }), function(item) {
        return item.property === property;
    });
}
var $2894580601046fed$var$Overrides_t_encode = $2894580601046fed$var$include.t_encode;
var $2894580601046fed$var$Overrides_t_decode = $2894580601046fed$var$include.t_decode;
var $2894580601046fed$var$Overrides_codec = $2894580601046fed$var$include.codec;
var $2894580601046fed$export$23b9aa6bc8814b5 = {
    Encode: $2894580601046fed$var$Encode,
    Decode: $2894580601046fed$var$Decode,
    toJson: $2894580601046fed$var$toJson,
    fromJson: $2894580601046fed$var$fromJson,
    t_encode: $2894580601046fed$var$Overrides_t_encode,
    t_decode: $2894580601046fed$var$Overrides_t_decode,
    codec: $2894580601046fed$var$Overrides_codec,
    getByConfigId: $2894580601046fed$var$getByConfigId,
    getByConfigIdAndProperty: $2894580601046fed$var$getByConfigIdAndProperty
};
 /* propertyFromJson Not a pure module */ 
});

parcelRegister("ij6do", function(module, exports) {

$parcel$export(module.exports, "CardSize", function () { return $d53ed27e8c71ce82$export$93c0382b74e40ff9; });
$parcel$export(module.exports, "Link", function () { return $d53ed27e8c71ce82$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "CategoryCard", function () { return $d53ed27e8c71ce82$export$5fbe069c73ec3073; });
$parcel$export(module.exports, "ExternalConnection", function () { return $d53ed27e8c71ce82$export$9b7d2686799c37a; });
$parcel$export(module.exports, "layout_fromJson", function () { return $d53ed27e8c71ce82$export$4e73ccac02f50c1c; });
$parcel$export(module.exports, "linkCategory_fromJson", function () { return $d53ed27e8c71ce82$export$4447e9406ed8729a; });
$parcel$export(module.exports, "categoryType_fromJson", function () { return $d53ed27e8c71ce82$export$9ebb77ea9091af9c; });
$parcel$export(module.exports, "category_fromJson", function () { return $d53ed27e8c71ce82$export$66ee41028aa2b6df; });
$parcel$export(module.exports, "taggedMedia_fromJson", function () { return $d53ed27e8c71ce82$export$c9a9d5efc52cc0e9; });
$parcel$export(module.exports, "taggedMediaSource_fromJson", function () { return $d53ed27e8c71ce82$export$b6ac0a9f368576b6; });
$parcel$export(module.exports, "quickviewCategory_fromJson", function () { return $d53ed27e8c71ce82$export$5855298e525169e0; });
$parcel$export(module.exports, "indexCategory_fromJson", function () { return $d53ed27e8c71ce82$export$b1fdf50be3d3b56a; });
$parcel$export(module.exports, "customComponentCategory_fromJson", function () { return $d53ed27e8c71ce82$export$ec0974398445544b; });
$parcel$export(module.exports, "configEmbedCategory_fromJson", function () { return $d53ed27e8c71ce82$export$34cabec5ccdcad25; });
$parcel$export(module.exports, "fromJson", function () { return $d53ed27e8c71ce82$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "Page", function () { return $d53ed27e8c71ce82$export$6955bcca4cd3539f; });
$parcel$export(module.exports, "empty", function () { return $d53ed27e8c71ce82$export$6e22c362a0406a2c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $bYadz = parcelRequire("bYadz");

var $jVmMx = parcelRequire("jVmMx");

var $1Gpco = parcelRequire("1Gpco");

var $dRfYk = parcelRequire("dRfYk");

var $aNn17 = parcelRequire("aNn17");

var $cXBWA = parcelRequire("cXBWA");

var $7lqRw = parcelRequire("7lqRw");

var $ZzK4r = parcelRequire("ZzK4r");

var $7Qe3X = parcelRequire("7Qe3X");

var $5lwUf = parcelRequire("5lwUf");

var $04dLg = parcelRequire("04dLg");

var $kM5sF = parcelRequire("kM5sF");

var $fnO65 = parcelRequire("fnO65");

var $cvFfT = parcelRequire("cvFfT");

var $5kJL4 = parcelRequire("5kJL4");
var $d53ed27e8c71ce82$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Xxxs",
        /* Xxxs */ 0
    ],
    [
        "Xxs",
        /* Xxs */ 1
    ],
    [
        "Xs",
        /* Xs */ 2
    ],
    [
        "Sm",
        /* Sm */ 3
    ],
    [
        "Md",
        /* Md */ 4
    ],
    [
        "Lg",
        /* Lg */ 5
    ],
    [
        "Xl",
        /* Xl */ 6
    ],
    [
        "Xxl",
        /* Xxl */ 7
    ],
    [
        "Xxxl",
        /* Xxxl */ 8
    ],
    [
        "Xxxxl",
        /* Xxxxl */ 9
    ],
    [
        "Xxxxxl",
        /* Xxxxxl */ 10
    ]
]);
var $d53ed27e8c71ce82$export$93c0382b74e40ff9 = {
    fromJson: $d53ed27e8c71ce82$var$fromJson
};
var $d53ed27e8c71ce82$var$categoryLink_fromJson = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "categoryId", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("filters", $iv6Yc._1($jVmMx.Decode.option, $bYadz.fromJson), undefined), function(categoryId, filters) {
    return {
        categoryId: categoryId,
        filters: filters
    };
});
var $d53ed27e8c71ce82$var$productLink_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "productId", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("variantId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined), $jVmMx.Decode.fieldWithDefault("productCategoryId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined), function(productId, variantId, productCategoryId) {
    return {
        productId: productId,
        variantId: variantId,
        productCategoryId: productCategoryId
    };
});
var $d53ed27e8c71ce82$var$storeCategoryLink_fromJson = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "categoryId", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("sortBy", $04dLg.ProductSortOrder.fromJson, /* Default */ 0), $iv6Yc._2($jVmMx.Decode.field, "count", $jVmMx.Decode.$$int), $jVmMx.Decode.fieldWithDefault("relatedMediaCount", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), function(categoryId, sortBy, count, relatedMediaCount) {
    return {
        categoryId: categoryId,
        sortBy: sortBy,
        count: count,
        relatedMediaCount: relatedMediaCount
    };
});
var $d53ed27e8c71ce82$var$customActionLink_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "customActionId", $dRfYk.fromJson), $iv6Yc._2($jVmMx.Decode.field, "code", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "name", $jVmMx.Decode.string), function(customActionId, code, name) {
    return {
        customActionId: customActionId,
        code: code,
        name: name
    };
});
var $d53ed27e8c71ce82$var$fromJson$1 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("URL", $jVmMx.Decode.string, function(str) {
    return {
        TAG: /* URL */ 0,
        _0: str
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Category", $d53ed27e8c71ce82$var$categoryLink_fromJson, function(str) {
        return {
            TAG: /* Category */ 1,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Product", $d53ed27e8c71ce82$var$productLink_fromJson, function(str) {
        return {
            TAG: /* Product */ 2,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("StoreCategory", $d53ed27e8c71ce82$var$storeCategoryLink_fromJson, function(str) {
        return {
            TAG: /* StoreCategory */ 3,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("CustomAction", $d53ed27e8c71ce82$var$customActionLink_fromJson, function(str) {
        return {
            TAG: /* CustomAction */ 4,
            _0: str
        };
    })
]);
var $d53ed27e8c71ce82$export$a6c7ac8248d6e38a = {
    fromJson: $d53ed27e8c71ce82$var$fromJson$1
};
var $d53ed27e8c71ce82$var$videoCard_fromJson = $iv6Yc._8($jVmMx.Decode.map7, $jVmMx.Decode.fieldWithDefault("link", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$1), undefined), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), $iv6Yc._2($jVmMx.Decode.field, "videoUrl", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("width", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("height", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("fallbackImageUrl", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined), function(link, size, shape, videoUrl, width, height, fallbackImageUrl) {
    return {
        link: link,
        size: size,
        shape: shape,
        videoUrl: videoUrl,
        width: width,
        height: height,
        fallbackImageUrl: fallbackImageUrl
    };
});
var $d53ed27e8c71ce82$var$imageCard_fromJson = $iv6Yc._7($jVmMx.Decode.map6, $jVmMx.Decode.fieldWithDefault("link", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$1), undefined), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), $iv6Yc._2($jVmMx.Decode.field, "imageUrl", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("width", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("height", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), function(link, size, shape, imageUrl, width, height) {
    return {
        link: link,
        size: size,
        shape: shape,
        imageUrl: imageUrl,
        width: width,
        height: height
    };
});
var $d53ed27e8c71ce82$var$imageLinkCard_fromJson = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "link", $d53ed27e8c71ce82$var$fromJson$1), $iv6Yc._2($jVmMx.Decode.field, "imageUrl", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), function(link, imageUrl, size, shape) {
    return {
        link: link,
        imageUrl: imageUrl,
        size: size,
        shape: shape
    };
});
var $d53ed27e8c71ce82$var$videoLinkCard_fromJson = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "link", $d53ed27e8c71ce82$var$fromJson$1), $iv6Yc._2($jVmMx.Decode.field, "videoUrl", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), $jVmMx.Decode.fieldWithDefault("fallbackImageUrl", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined), function(link, videoUrl, size, shape, fallbackImageUrl) {
    return {
        link: link,
        videoUrl: videoUrl,
        size: size,
        shape: shape,
        fallbackImageUrl: fallbackImageUrl
    };
});
var $d53ed27e8c71ce82$var$medialessCard_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "link", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$1)), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), function(link, size, shape) {
    return {
        link: link,
        size: size,
        shape: shape
    };
});
var $d53ed27e8c71ce82$var$medialessLinkCard_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "link", $d53ed27e8c71ce82$var$fromJson$1), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), function(link, size, shape) {
    return {
        link: link,
        size: size,
        shape: shape
    };
});
var $d53ed27e8c71ce82$var$imageDisplayCard_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "imageUrl", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), function(imageUrl, size, shape) {
    return {
        imageUrl: imageUrl,
        size: size,
        shape: shape
    };
});
var $d53ed27e8c71ce82$var$videoDisplayCard_fromJson = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "videoUrl", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("size", $d53ed27e8c71ce82$var$fromJson, /* Lg */ 5), $jVmMx.Decode.fieldWithDefault("shape", $5kJL4.cardShape_fromJson, /* Square */ 1), $iv6Yc._2($jVmMx.Decode.field, "fallbackImageUrl", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), function(videoUrl, size, shape, fallbackImageUrl) {
    return {
        videoUrl: videoUrl,
        size: size,
        shape: shape,
        fallbackImageUrl: fallbackImageUrl
    };
});
var $d53ed27e8c71ce82$var$fromJson$2 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("ImageLinkCard", $d53ed27e8c71ce82$var$imageLinkCard_fromJson, function(payload) {
    return {
        TAG: /* ImageLinkCard */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("VideoLinkCard", $d53ed27e8c71ce82$var$videoLinkCard_fromJson, function(payload) {
        return {
            TAG: /* VideoLinkCard */ 1,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ImageCard", $d53ed27e8c71ce82$var$imageCard_fromJson, function(payload) {
        return {
            TAG: /* ImageCard */ 2,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("VideoCard", $d53ed27e8c71ce82$var$videoCard_fromJson, function(payload) {
        return {
            TAG: /* VideoCard */ 3,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("MedialessCard", $d53ed27e8c71ce82$var$medialessCard_fromJson, function(payload) {
        return {
            TAG: /* MedialessCard */ 4,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("MedialessLinkCard", $d53ed27e8c71ce82$var$medialessLinkCard_fromJson, function(payload) {
        return {
            TAG: /* MedialessLinkCard */ 5,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ImageDisplayCard", $d53ed27e8c71ce82$var$imageDisplayCard_fromJson, function(payload) {
        return {
            TAG: /* ImageDisplayCard */ 6,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("VideoDisplayCard", $d53ed27e8c71ce82$var$videoDisplayCard_fromJson, function(payload) {
        return {
            TAG: /* VideoDisplayCard */ 7,
            _0: payload
        };
    })
]);
var $d53ed27e8c71ce82$export$5fbe069c73ec3073 = {
    videoCard_fromJson: $d53ed27e8c71ce82$var$videoCard_fromJson,
    imageCard_fromJson: $d53ed27e8c71ce82$var$imageCard_fromJson,
    imageLinkCard_fromJson: $d53ed27e8c71ce82$var$imageLinkCard_fromJson,
    videoLinkCard_fromJson: $d53ed27e8c71ce82$var$videoLinkCard_fromJson,
    medialessCard_fromJson: $d53ed27e8c71ce82$var$medialessCard_fromJson,
    medialessLinkCard_fromJson: $d53ed27e8c71ce82$var$medialessLinkCard_fromJson,
    imageDisplayCard_fromJson: $d53ed27e8c71ce82$var$imageDisplayCard_fromJson,
    videoDisplayCard_fromJson: $d53ed27e8c71ce82$var$videoDisplayCard_fromJson,
    fromJson: $d53ed27e8c71ce82$var$fromJson$2
};
var $d53ed27e8c71ce82$var$storeCategoryConnection_fromJson = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "categoryId", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "sortBy", $kM5sF.ProductSortOrder.fromJson), $jVmMx.Decode.fieldWithDefault("filterBy", $iv6Yc._1($jVmMx.Decode.option, $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.string)), undefined), $iv6Yc._2($jVmMx.Decode.field, "count", $jVmMx.Decode.$$int), $jVmMx.Decode.fieldWithDefault("relatedMediaCount", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), function(categoryId, sortBy, filterBy, count, relatedMediaCount) {
    return {
        categoryId: categoryId,
        sortBy: sortBy,
        filterBy: filterBy,
        count: count,
        relatedMediaCount: relatedMediaCount
    };
});
var $d53ed27e8c71ce82$var$configEmbedConnection_fromJson = $iv6Yc._2($jVmMx.Decode.map, $iv6Yc._2($jVmMx.Decode.field, "configId", $jVmMx.Decode.string), function(configId) {
    return {
        configId: configId
    };
});
var $d53ed27e8c71ce82$var$fromJson$3 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("StoreCategory", $d53ed27e8c71ce82$var$storeCategoryConnection_fromJson, function(payload) {
    return {
        TAG: /* StoreCategory */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("ConfigEmbed", $d53ed27e8c71ce82$var$configEmbedConnection_fromJson, function(payload) {
        return {
            TAG: /* ConfigEmbed */ 1,
            _0: payload
        };
    }),
    $jVmMx.Decode.simpleVariant([
        [
            "History",
            /* History */ 0
        ]
    ]),
    $jVmMx.Decode.simpleVariant([
        [
            "Favorites",
            /* Favorites */ 1
        ]
    ]),
    $jVmMx.Decode.simpleVariant([
        [
            "StoreCart",
            /* StoreCart */ 2
        ]
    ])
]);
var $d53ed27e8c71ce82$var$t_v1_fromJson = $iv6Yc._2($jVmMx.Decode.andThen, $d53ed27e8c71ce82$var$storeCategoryConnection_fromJson, function(connection) {
    return $iv6Yc._1($jVmMx.Decode.succeed, {
        TAG: /* StoreCategory */ 0,
        _0: connection
    });
});
var $d53ed27e8c71ce82$var$fromJson$4 = $79vie.oneOf($d53ed27e8c71ce82$var$fromJson$3, [
    $d53ed27e8c71ce82$var$t_v1_fromJson
]);
var $d53ed27e8c71ce82$export$9b7d2686799c37a = {
    storeCategoryConnection_fromJson: $d53ed27e8c71ce82$var$storeCategoryConnection_fromJson,
    configEmbedConnection_fromJson: $d53ed27e8c71ce82$var$configEmbedConnection_fromJson,
    t_v1_fromJson: $d53ed27e8c71ce82$var$t_v1_fromJson,
    fromJson: $d53ed27e8c71ce82$var$fromJson$4
};
var $d53ed27e8c71ce82$export$4e73ccac02f50c1c = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("SubCategoriesSlider", $5kJL4.sliderPayload_fromJson, function(payload) {
    return {
        TAG: /* SubCategoriesSlider */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("SubCategoriesSliderWithHeader", $5kJL4.sliderPayload_fromJson, function(payload) {
        return {
            TAG: /* SubCategoriesSliderWithHeader */ 1,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("SubCategoriesGrid", $5kJL4.gridPayload_fromJson, function(payload) {
        return {
            TAG: /* SubCategoriesGrid */ 2,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ProductGrid", $5kJL4.gridPayload_fromJson, function(payload) {
        return {
            TAG: /* ProductGrid */ 3,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ProductSlider", $5kJL4.sliderPayload_fromJson, function(payload) {
        return {
            TAG: /* ProductSlider */ 4,
            _0: payload
        };
    }),
    $jVmMx.Decode.simpleVariant([
        [
            "NoLayout",
            /* NoLayout */ 0
        ]
    ])
]);
var $d53ed27e8c71ce82$export$4447e9406ed8729a = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "link", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("imageWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("imageHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), function(link, imageWidth, imageHeight) {
    return {
        link: link,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    };
});
function $d53ed27e8c71ce82$var$fromJson$5(param) {
    return $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(id, title, description, showTitle, showDescription, visible, visibleInMenuBar, visibleInSectionList, visibleInParent, visibleInHeaderSlider, listPageActiveLayout, userSelectedLayout, forcedPLPLayout, tabbedSubCategories, card, categoryType, socialNetworkSource, displayPriority, expandVariantsInProductsListing, lastModifiedAt, sectionTheme, pageTheme, stickySection) {
        return {
            id: id,
            title: title,
            description: description,
            showTitle: showTitle,
            showDescription: showDescription,
            visible: visible,
            visibleInMenuBar: visibleInMenuBar,
            visibleInSectionList: visibleInSectionList,
            visibleInParent: visibleInParent,
            visibleInHeaderSlider: visibleInHeaderSlider,
            listPageActiveLayout: listPageActiveLayout,
            userSelectedLayout: userSelectedLayout,
            forcedPLPLayout: forcedPLPLayout,
            tabbedSubCategories: tabbedSubCategories,
            card: card,
            categoryType: categoryType,
            socialNetworkSource: socialNetworkSource,
            displayPriority: displayPriority,
            expandVariantsInProductsListing: expandVariantsInProductsListing,
            lastModifiedAt: lastModifiedAt,
            sectionTheme: sectionTheme,
            pageTheme: pageTheme,
            stickySection: stickySection
        };
    }), $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("title", $jVmMx.Decode.string, "")), $jVmMx.Decode.fieldWithDefault("description", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("showTitle", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("showDescription", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visible", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInMenuBar", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInSectionList", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInParent", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInHeaderSlider", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("listPageActiveLayout", $d53ed27e8c71ce82$export$4e73ccac02f50c1c, /* NoLayout */ 0)), $jVmMx.Decode.fieldWithDefault("userSelectedLayout", $d53ed27e8c71ce82$export$4e73ccac02f50c1c, /* NoLayout */ 0)), $jVmMx.Decode.fieldWithDefault("forcedPLPLayout", $d53ed27e8c71ce82$export$4e73ccac02f50c1c, /* NoLayout */ 0)), $jVmMx.Decode.fieldWithDefault("tabbedSubCategories", $iv6Yc._1($jVmMx.Decode.option, $fnO65.CategoryTabSettings.fromJson), undefined)), $iv6Yc._2($jVmMx.Decode.field, "card", $d53ed27e8c71ce82$var$fromJson$2)), $iv6Yc._2($jVmMx.Decode.field, "categoryType", $d53ed27e8c71ce82$export$9ebb77ea9091af9c(undefined))), $jVmMx.Decode.fieldWithDefault("socialNetworkSource", $iv6Yc._1($jVmMx.Decode.option, $cvFfT.SocialNetworkSource.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("displayPriority", $5lwUf.DisplayPriority.fromJson, /* ChildrenFirst */ 0)), $jVmMx.Decode.fieldWithDefault("expandVariantsInProductsListing", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool), undefined)), $jVmMx.Decode.fieldWithDefault("lastModifiedAt", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$float), undefined)), $jVmMx.Decode.fieldWithDefault("sectionTheme", $1Gpco.reference_fromJson, /* LegacyTheme */ 0)), $jVmMx.Decode.fieldWithDefault("pageTheme", $1Gpco.reference_fromJson, /* LegacyTheme */ 0)), $jVmMx.Decode.fieldWithDefault("stickySection", $jVmMx.Decode.bool, false));
}
function $d53ed27e8c71ce82$export$66ee41028aa2b6df(param) {
    return $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(firstCard, externalConnection, children, loadMoreChildren, totalChildren, link, products, taggedMedia, imageHotspots, imageWidth, imageHeight) {
        return {
            firstCard: firstCard,
            externalConnection: externalConnection,
            children: children,
            loadMoreChildren: loadMoreChildren,
            totalChildren: totalChildren,
            link: link,
            products: products,
            taggedMedia: taggedMedia,
            imageHotspots: imageHotspots,
            imageWidth: imageWidth,
            imageHeight: imageHeight
        };
    }), $jVmMx.Decode.fieldWithDefault("firstCard", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$2), undefined)), $jVmMx.Decode.fieldWithDefault("externalConnection", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$4), undefined)), $iv6Yc._2($jVmMx.Decode.field, "children", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.lazy_(function(param) {
        return $d53ed27e8c71ce82$var$fromJson$5(undefined);
    })))), $jVmMx.Decode.fieldWithDefault("loadMoreChildren", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("totalChildren", $jVmMx.Decode.$$int, 0)), $jVmMx.Decode.fieldWithDefault("link", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("products", $7Qe3X.TaggedProducts.fromJson, [])), $jVmMx.Decode.fieldWithDefault("taggedMedia", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$export$c9a9d5efc52cc0e9(undefined)), undefined)), $jVmMx.Decode.fieldWithDefault("imageHotspots", $iv6Yc._1($jVmMx.Decode.option, $iv6Yc._1($jVmMx.Decode.array, $cXBWA.fromJson)), undefined)), $jVmMx.Decode.fieldWithDefault("imageWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("imageHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined));
}
function $d53ed27e8c71ce82$export$b6ac0a9f368576b6(param) {
    return $79vie.oneOf($jVmMx.Decode.deccoVariantWithPayload("Manual", $79vie.array($jVmMx.Decode.lazy_(function(param) {
        return $d53ed27e8c71ce82$var$fromJson$5(undefined);
    })), function(payload) {
        return /* Manual */ {
            _0: payload
        };
    }), []);
}
function $d53ed27e8c71ce82$export$c9a9d5efc52cc0e9(param) {
    return $iv6Yc._8($jVmMx.Decode.map7, $iv6Yc._2($jVmMx.Decode.field, "source", $d53ed27e8c71ce82$export$b6ac0a9f368576b6(undefined)), $jVmMx.Decode.fieldWithDefault("displayType", $ZzK4r.TaggedMedia.displayType_fromJson, /* InlineDisplay */ 0), $jVmMx.Decode.fieldWithDefault("cardWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("cardHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("startRowOffset", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("slidesPerView", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$float), undefined), $jVmMx.Decode.fieldWithDefault("imageFit", $ZzK4r.TaggedMedia.imageFit_fromJson, /* FitCover */ 0), function(source, displayType, cardWidth, cardHeight, startRowOffset, slidesPerView, imageFit) {
        return {
            source: source,
            displayType: displayType,
            cardWidth: cardWidth,
            cardHeight: cardHeight,
            startRowOffset: startRowOffset,
            slidesPerView: slidesPerView,
            imageFit: imageFit
        };
    });
}
function $d53ed27e8c71ce82$export$5855298e525169e0(param) {
    return $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(isStories, isPinned, firstCard, externalConnection, children, loadMoreChildren, totalChildren, link, products, imageHotspots, imageWidth, imageHeight) {
        return {
            isStories: isStories,
            isPinned: isPinned,
            firstCard: firstCard,
            externalConnection: externalConnection,
            children: children,
            loadMoreChildren: loadMoreChildren,
            totalChildren: totalChildren,
            link: link,
            products: products,
            imageHotspots: imageHotspots,
            imageWidth: imageWidth,
            imageHeight: imageHeight
        };
    }), $jVmMx.Decode.fieldWithDefault("isStories", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("isPinned", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("firstCard", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$2), undefined)), $jVmMx.Decode.fieldWithDefault("externalConnection", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$4), undefined)), $iv6Yc._2($jVmMx.Decode.field, "children", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.lazy_(function(param) {
        return $d53ed27e8c71ce82$var$fromJson$5(undefined);
    })))), $jVmMx.Decode.fieldWithDefault("loadMoreChildren", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("totalChildren", $jVmMx.Decode.$$int, 0)), $jVmMx.Decode.fieldWithDefault("link", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("products", $7Qe3X.TaggedProducts.fromJson, [])), $jVmMx.Decode.fieldWithDefault("imageHotspots", $iv6Yc._1($jVmMx.Decode.option, $iv6Yc._1($jVmMx.Decode.array, $cXBWA.fromJson)), undefined)), $jVmMx.Decode.fieldWithDefault("imageWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("imageHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined));
}
function $d53ed27e8c71ce82$export$b1fdf50be3d3b56a(param) {
    return $iv6Yc._4($jVmMx.Decode.map3, $jVmMx.Decode.fieldWithDefault("externalConnection", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$4), undefined), $jVmMx.Decode.fieldWithDefault("taggedMedia", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$export$c9a9d5efc52cc0e9(undefined)), undefined), $jVmMx.Decode.fieldWithDefault("products", $7Qe3X.TaggedProducts.fromJson, []), function(externalConnection, taggedMedia, products) {
        return {
            externalConnection: externalConnection,
            taggedMedia: taggedMedia,
            products: products
        };
    });
}
function $d53ed27e8c71ce82$export$ec0974398445544b(param) {
    return $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(component) {
        return {
            component: component
        };
    }), $iv6Yc._2($jVmMx.Decode.field, "component", $7lqRw.reference_fromJson));
}
function $d53ed27e8c71ce82$export$34cabec5ccdcad25(param) {
    return $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(firstCard, configId, children, loadMoreChildren, totalChildren, link, products, taggedMedia, imageHotspots, imageWidth, imageHeight) {
        return {
            firstCard: firstCard,
            configId: configId,
            children: children,
            loadMoreChildren: loadMoreChildren,
            totalChildren: totalChildren,
            link: link,
            products: products,
            taggedMedia: taggedMedia,
            imageHotspots: imageHotspots,
            imageWidth: imageWidth,
            imageHeight: imageHeight
        };
    }), $jVmMx.Decode.fieldWithDefault("firstCard", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$var$fromJson$2), undefined)), $iv6Yc._2($jVmMx.Decode.field, "configId", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "children", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.lazy_(function(param) {
        return $d53ed27e8c71ce82$var$fromJson$5(undefined);
    })))), $jVmMx.Decode.fieldWithDefault("loadMoreChildren", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("totalChildren", $jVmMx.Decode.$$int, 0)), $jVmMx.Decode.fieldWithDefault("link", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("products", $7Qe3X.TaggedProducts.fromJson, [])), $jVmMx.Decode.fieldWithDefault("taggedMedia", $iv6Yc._1($jVmMx.Decode.option, $d53ed27e8c71ce82$export$c9a9d5efc52cc0e9(undefined)), undefined)), $jVmMx.Decode.fieldWithDefault("imageHotspots", $iv6Yc._1($jVmMx.Decode.option, $iv6Yc._1($jVmMx.Decode.array, $cXBWA.fromJson)), undefined)), $jVmMx.Decode.fieldWithDefault("imageWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("imageHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined));
}
function $d53ed27e8c71ce82$export$9ebb77ea9091af9c(param) {
    return $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Link", $d53ed27e8c71ce82$export$4447e9406ed8729a, function(payload) {
        return {
            TAG: /* Link */ 0,
            _0: payload
        };
    }), [
        $jVmMx.Decode.deccoVariantWithPayload("Standard", $d53ed27e8c71ce82$export$66ee41028aa2b6df(undefined), function(payload) {
            return {
                TAG: /* Standard */ 1,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("QuickView", $d53ed27e8c71ce82$export$5855298e525169e0(undefined), function(payload) {
            return {
                TAG: /* QuickView */ 2,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("Index", $d53ed27e8c71ce82$export$b1fdf50be3d3b56a(undefined), function(payload) {
            return {
                TAG: /* Index */ 3,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("ConfigEmbed", $d53ed27e8c71ce82$export$34cabec5ccdcad25(undefined), function(payload) {
            return {
                TAG: /* ConfigEmbed */ 4,
                _0: payload
            };
        }),
        $jVmMx.Decode.simpleVariant([
            [
                "Page",
                /* Page */ 0
            ]
        ]),
        $jVmMx.Decode.deccoVariantWithPayload("CustomComponentSection", $d53ed27e8c71ce82$export$ec0974398445544b(undefined), function(payload) {
            return {
                TAG: /* CustomComponentSection */ 5,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("EmbedCodeSection", $aNn17.t_decode, function(payload) {
            return {
                TAG: /* EmbedCodeSection */ 6,
                _0: payload
            };
        })
    ]);
}
var $d53ed27e8c71ce82$export$7ae2d2a8b28a8cb8 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(id, title, description, showTitle, showDescription, visible, visibleInMenuBar, visibleInSectionList, visibleInParent, visibleInHeaderSlider, listPageActiveLayout, userSelectedLayout, forcedPLPLayout, tabbedSubCategories, card, categoryType, socialNetworkSource, displayPriority, expandVariantsInProductsListing, lastModifiedAt, sectionTheme, pageTheme, stickySection) {
    return {
        id: id,
        title: title,
        description: description,
        showTitle: showTitle,
        showDescription: showDescription,
        visible: visible,
        visibleInMenuBar: visibleInMenuBar,
        visibleInSectionList: visibleInSectionList,
        visibleInParent: visibleInParent,
        visibleInHeaderSlider: visibleInHeaderSlider,
        listPageActiveLayout: listPageActiveLayout,
        userSelectedLayout: userSelectedLayout,
        forcedPLPLayout: forcedPLPLayout,
        tabbedSubCategories: tabbedSubCategories,
        card: card,
        categoryType: categoryType,
        socialNetworkSource: socialNetworkSource,
        displayPriority: displayPriority,
        expandVariantsInProductsListing: expandVariantsInProductsListing,
        lastModifiedAt: lastModifiedAt,
        sectionTheme: sectionTheme,
        pageTheme: pageTheme,
        stickySection: stickySection
    };
}), $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("title", $jVmMx.Decode.string, "")), $jVmMx.Decode.fieldWithDefault("description", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("showTitle", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("showDescription", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visible", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInMenuBar", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInSectionList", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInParent", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("visibleInHeaderSlider", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("listPageActiveLayout", $d53ed27e8c71ce82$export$4e73ccac02f50c1c, /* NoLayout */ 0)), $jVmMx.Decode.fieldWithDefault("userSelectedLayout", $d53ed27e8c71ce82$export$4e73ccac02f50c1c, /* NoLayout */ 0)), $jVmMx.Decode.fieldWithDefault("forcedPLPLayout", $d53ed27e8c71ce82$export$4e73ccac02f50c1c, /* NoLayout */ 0)), $jVmMx.Decode.fieldWithDefault("tabbedSubCategories", $iv6Yc._1($jVmMx.Decode.option, $fnO65.CategoryTabSettings.fromJson), undefined)), $iv6Yc._2($jVmMx.Decode.field, "card", $d53ed27e8c71ce82$var$fromJson$2)), $iv6Yc._2($jVmMx.Decode.field, "categoryType", $d53ed27e8c71ce82$export$9ebb77ea9091af9c(undefined))), $jVmMx.Decode.fieldWithDefault("socialNetworkSource", $iv6Yc._1($jVmMx.Decode.option, $cvFfT.SocialNetworkSource.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("displayPriority", $5lwUf.DisplayPriority.fromJson, /* ChildrenFirst */ 0)), $jVmMx.Decode.fieldWithDefault("expandVariantsInProductsListing", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool), undefined)), $jVmMx.Decode.fieldWithDefault("lastModifiedAt", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$float), undefined)), $jVmMx.Decode.fieldWithDefault("sectionTheme", $1Gpco.reference_fromJson, /* LegacyTheme */ 0)), $jVmMx.Decode.fieldWithDefault("pageTheme", $1Gpco.reference_fromJson, /* LegacyTheme */ 0)), $jVmMx.Decode.fieldWithDefault("stickySection", $jVmMx.Decode.bool, false));
var $d53ed27e8c71ce82$var$fromJson$7 = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "categories", $iv6Yc._1($jVmMx.Decode.array, $d53ed27e8c71ce82$export$7ae2d2a8b28a8cb8)), $iv6Yc._2($jVmMx.Decode.field, "previous", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "next", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("offset", $jVmMx.Decode.$$int, 0), $jVmMx.Decode.fieldWithDefault("total", $jVmMx.Decode.$$int, 0), function(categories, previous, next, offset, total) {
    return {
        categories: categories,
        previous: previous,
        next: next,
        offset: offset,
        total: total
    };
});
var $d53ed27e8c71ce82$export$6955bcca4cd3539f = {
    fromJson: $d53ed27e8c71ce82$var$fromJson$7
};
var $d53ed27e8c71ce82$export$6e22c362a0406a2c = {
    id: "",
    title: "",
    description: undefined,
    showTitle: true,
    showDescription: true,
    visible: true,
    visibleInMenuBar: true,
    visibleInSectionList: true,
    visibleInParent: true,
    visibleInHeaderSlider: true,
    listPageActiveLayout: {
        TAG: /* SubCategoriesGrid */ 2,
        _0: {
            columns: /* FourColumnGrid */ 3,
            gap: /* Equal */ 0,
            maxRows: undefined,
            maxWidth: undefined,
            padding: undefined,
            pattern: undefined
        }
    },
    userSelectedLayout: {
        TAG: /* SubCategoriesGrid */ 2,
        _0: {
            columns: /* FourColumnGrid */ 3,
            gap: /* Equal */ 0,
            maxRows: undefined,
            maxWidth: undefined,
            padding: undefined,
            pattern: undefined
        }
    },
    forcedPLPLayout: {
        TAG: /* ProductGrid */ 3,
        _0: {
            columns: /* FourColumnGrid */ 3,
            gap: /* Equal */ 0,
            maxRows: undefined,
            maxWidth: undefined,
            padding: undefined,
            pattern: undefined
        }
    },
    tabbedSubCategories: undefined,
    card: {
        TAG: /* ImageLinkCard */ 0,
        _0: {
            link: {
                TAG: /* URL */ 0,
                _0: ""
            },
            imageUrl: "",
            size: /* Md */ 4,
            shape: /* Square */ 1
        }
    },
    categoryType: {
        TAG: /* Link */ 0,
        _0: {
            link: "",
            imageWidth: undefined,
            imageHeight: undefined
        }
    },
    socialNetworkSource: undefined,
    displayPriority: /* ChildrenFirst */ 0,
    expandVariantsInProductsListing: undefined,
    lastModifiedAt: undefined,
    sectionTheme: /* LegacyTheme */ 0,
    pageTheme: /* LegacyTheme */ 0,
    stickySection: false
};
 /* fromJson Not a pure module */ 
});
parcelRegister("aNn17", function(module, exports) {

$parcel$export(module.exports, "t_encode", function () { return $7dc055ac0cae2e63$export$cc42ff7b6c615091; });
$parcel$export(module.exports, "t_decode", function () { return $7dc055ac0cae2e63$export$bb5e712207166a02; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");
function $7dc055ac0cae2e63$export$356ef11d02801a41(t) {
    if (t) return $jVmMx.Encode.deccoVariantWithPayload(t._0, "Int", $jVmMx.Encode.$$int);
    else return $jVmMx.Encode.simpleVariant([
        [
            "Auto",
            /* Auto */ 0
        ]
    ], t);
}
var $7dc055ac0cae2e63$export$f614c35f717085b7 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Int", $jVmMx.Decode.$$int, function(i) {
    return /* Int */ {
        _0: i
    };
}), [
    $jVmMx.Decode.simpleVariant([
        [
            "Auto",
            /* Auto */ 0
        ]
    ])
]);
function $7dc055ac0cae2e63$export$cc42ff7b6c615091(t) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "code",
            $iv6Yc._1($jVmMx.Encode.string, t.code)
        ],
        [
            "size",
            $iv6Yc._2($jVmMx.Encode.array, [
                t.size[0],
                t.size[1]
            ], $7dc055ac0cae2e63$export$356ef11d02801a41)
        ]
    ]);
}
var $7dc055ac0cae2e63$export$bb5e712207166a02 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(code, size) {
    return {
        code: code,
        size: size
    };
}), $iv6Yc._2($jVmMx.Decode.field, "code", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "size", $iv6Yc._2($jVmMx.Decode.tuple2, $7dc055ac0cae2e63$export$f614c35f717085b7, $7dc055ac0cae2e63$export$f614c35f717085b7)));
 /* size_decode Not a pure module */ 
});

parcelRegister("cXBWA", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $96f86d9b84470f00$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $96f86d9b84470f00$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $96f86d9b84470f00$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "x",
            $iv6Yc._1($jVmMx.Encode.$$int, param.x)
        ],
        [
            "y",
            $iv6Yc._1($jVmMx.Encode.$$int, param.y)
        ],
        [
            "google_feed_id",
            $iv6Yc._1($jVmMx.Encode.string, param.productId)
        ],
        [
            "variantId",
            $jVmMx.Encode.nullable(param.variantId, $jVmMx.Encode.string)
        ],
        [
            "visible",
            $jVmMx.Encode.nullable(param.visible, $jVmMx.Encode.bool)
        ]
    ]);
}
var $96f86d9b84470f00$export$7ae2d2a8b28a8cb8 = $79vie.map6($79vie.field("id", $79vie.string), $79vie.field("x", $79vie.$$int), $79vie.field("y", $79vie.$$int), $79vie.field("google_feed_id", $79vie.string), $79vie.field("variantId", $79vie.nullable($79vie.string)), $79vie.field("visible", $79vie.nullable($79vie.bool)), function(id, x, y, productId, variantId, visible) {
    return {
        id: id,
        x: x,
        y: y,
        productId: productId,
        variantId: variantId,
        visible: visible
    };
});
var $96f86d9b84470f00$var$include = $doJJK.Make({
    toJson: $96f86d9b84470f00$export$d5b7a8bf56ee1fe2,
    fromJson: $96f86d9b84470f00$export$7ae2d2a8b28a8cb8
});
var $96f86d9b84470f00$export$cc42ff7b6c615091 = $96f86d9b84470f00$var$include.t_encode;
var $96f86d9b84470f00$export$bb5e712207166a02 = $96f86d9b84470f00$var$include.t_decode;
var $96f86d9b84470f00$export$1c37c01eba8ed446 = $96f86d9b84470f00$var$include.codec;
 /* fromJson Not a pure module */ 
});

parcelRegister("7lqRw", function(module, exports) {

$parcel$export(module.exports, "reference_toJson", function () { return $558f54d51306072b$export$b959f71adeda4ed6; });
$parcel$export(module.exports, "reference_fromJson", function () { return $558f54d51306072b$export$c09225d5aa9e9604; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $iCR57 = parcelRequire("iCR57");
function $558f54d51306072b$export$3da5ea18781e244d(t) {
    if (typeof t === "number") return $jVmMx.Encode.simpleVariant([
        [
            "Unknown",
            /* Unknown */ 0
        ]
    ], /* Unknown */ 0);
    switch(t.TAG | 0){
        case /* String */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "String", $jVmMx.Encode.string);
        case /* Number */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "Number", $jVmMx.Encode.$$float);
        case /* Boolean */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "Boolean", $jVmMx.Encode.bool);
    }
}
var $558f54d51306072b$export$673e52a1ed88e3a6 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("String", $jVmMx.Decode.string, function(s) {
    return {
        TAG: /* String */ 0,
        _0: s
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Number", $jVmMx.Decode.$$float, function(f) {
        return {
            TAG: /* Number */ 1,
            _0: f
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Boolean", $jVmMx.Decode.bool, function(b) {
        return {
            TAG: /* Boolean */ 2,
            _0: b
        };
    }),
    $jVmMx.Decode.simpleVariant([
        [
            "Unknown",
            /* Unknown */ 0
        ]
    ])
]);
function $558f54d51306072b$export$b959f71adeda4ed6(t) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($iCR57.toJson, t.id)
        ],
        [
            "name",
            $iv6Yc._1($jVmMx.Encode.string, t.name)
        ],
        [
            "version",
            $iv6Yc._1($jVmMx.Encode.string, t.version)
        ],
        [
            "componentUrl",
            $iv6Yc._1($jVmMx.Encode.string, t.componentUrl)
        ],
        [
            "props",
            $jVmMx.Encode.dictWithEncoder(t.props, $558f54d51306072b$export$3da5ea18781e244d)
        ]
    ]);
}
var $558f54d51306072b$export$c09225d5aa9e9604 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(id, name, version, componentUrl, props) {
    return {
        id: id,
        name: name,
        version: version,
        componentUrl: componentUrl,
        props: props
    };
}), $iv6Yc._2($jVmMx.Decode.field, "id", $iCR57.fromJson)), $iv6Yc._2($jVmMx.Decode.field, "name", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "version", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "componentUrl", $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("props", $iv6Yc._1($jVmMx.Decode.dict, $558f54d51306072b$export$673e52a1ed88e3a6), {}));
 /* propValue_fromJson Not a pure module */ 
});
parcelRegister("iCR57", function(module, exports) {

$parcel$export(module.exports, "toString", function () { return $d8f4f37f97a840d0$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "fromJson", function () { return $d8f4f37f97a840d0$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "toJson", function () { return $d8f4f37f97a840d0$export$d5b7a8bf56ee1fe2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $d8f4f37f97a840d0$export$391a5bbc85d0d67d = $ki9MN.Make({});
var $d8f4f37f97a840d0$export$bb5e712207166a02 = $d8f4f37f97a840d0$export$391a5bbc85d0d67d.t_decode;
var $d8f4f37f97a840d0$export$cc42ff7b6c615091 = $d8f4f37f97a840d0$export$391a5bbc85d0d67d.t_encode;
var $d8f4f37f97a840d0$export$3004f64547af360e = $d8f4f37f97a840d0$export$391a5bbc85d0d67d.fromString;
var $d8f4f37f97a840d0$export$f84e8e69fd4488a5 = $d8f4f37f97a840d0$export$391a5bbc85d0d67d.toString;
var $d8f4f37f97a840d0$export$7ae2d2a8b28a8cb8 = $d8f4f37f97a840d0$export$391a5bbc85d0d67d.fromJson;
var $d8f4f37f97a840d0$export$d5b7a8bf56ee1fe2 = $d8f4f37f97a840d0$export$391a5bbc85d0d67d.toJson;
 /* CustomComponentId Not a pure module */ 
});


parcelRegister("ZzK4r", function(module, exports) {

$parcel$export(module.exports, "TaggedMedia", function () { return $0b916c4066f75179$export$5600df035d4a4579; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $gZgAC = parcelRequire("gZgAC");
function $0b916c4066f75179$var$source_toJson(source) {
    return $jVmMx.Encode.deccoVariantWithPayload(source._0, "Manual", function(__x) {
        return $iv6Yc._2($jVmMx.Encode.array, __x, $gZgAC.NodeBreakpoint.node_encode);
    });
}
var $0b916c4066f75179$var$source_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Manual", $iv6Yc._1($jVmMx.Decode.array, $gZgAC.NodeBreakpoint.node_decode), function(payload) {
    return /* Manual */ {
        _0: payload
    };
}), []);
function $0b916c4066f75179$var$displayType_toJson(displayType) {
    return $jVmMx.Encode.simpleVariant([
        [
            "InlineDisplay",
            /* InlineDisplay */ 0
        ],
        [
            "SliderDisplay",
            /* SliderDisplay */ 1
        ]
    ], displayType);
}
var $0b916c4066f75179$var$displayType_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.simpleVariant([
    [
        "InlineDisplay",
        /* InlineDisplay */ 0
    ]
]), [
    $jVmMx.Decode.simpleVariant([
        [
            "SliderDisplay",
            /* SliderDisplay */ 1
        ]
    ])
]);
function $0b916c4066f75179$var$imageFit_toJson(imageFit) {
    return $jVmMx.Encode.simpleVariant([
        [
            "FitCover",
            /* FitCover */ 0
        ],
        [
            "FitContain",
            /* FitContain */ 1
        ]
    ], imageFit);
}
var $0b916c4066f75179$var$imageFit_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.simpleVariant([
    [
        "FitCover",
        /* FitCover */ 0
    ]
]), [
    $jVmMx.Decode.simpleVariant([
        [
            "FitContain",
            /* FitContain */ 1
        ]
    ])
]);
function $0b916c4066f75179$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "source",
            $0b916c4066f75179$var$source_toJson(param.source)
        ],
        [
            "displayType",
            $0b916c4066f75179$var$displayType_toJson(param.displayType)
        ],
        [
            "cardWidth",
            $jVmMx.Encode.nullable(param.cardWidth, $jVmMx.Encode.$$int)
        ],
        [
            "cardHeight",
            $jVmMx.Encode.nullable(param.cardHeight, $jVmMx.Encode.$$int)
        ],
        [
            "startRowOffset",
            $jVmMx.Encode.nullable(param.startRowOffset, $jVmMx.Encode.$$int)
        ],
        [
            "imageFit",
            $0b916c4066f75179$var$imageFit_toJson(param.imageFit)
        ]
    ]);
}
var $0b916c4066f75179$var$fromJson = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "source", $0b916c4066f75179$var$source_fromJson), $jVmMx.Decode.fieldWithDefault("displayType", $0b916c4066f75179$var$displayType_fromJson, /* InlineDisplay */ 0), $jVmMx.Decode.fieldWithDefault("cardWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("cardHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("startRowOffset", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("imageFit", $0b916c4066f75179$var$imageFit_fromJson, /* FitCover */ 0), function(source, displayType, cardWidth, cardHeight, startRowOffset, imageFit) {
    return {
        source: source,
        displayType: displayType,
        cardWidth: cardWidth,
        cardHeight: cardHeight,
        startRowOffset: startRowOffset,
        imageFit: imageFit
    };
});
var $0b916c4066f75179$var$include = $doJJK.Make({
    toJson: $0b916c4066f75179$var$toJson,
    fromJson: $0b916c4066f75179$var$fromJson
});
var $0b916c4066f75179$var$TaggedMedia_t_encode = $0b916c4066f75179$var$include.t_encode;
var $0b916c4066f75179$var$TaggedMedia_t_decode = $0b916c4066f75179$var$include.t_decode;
var $0b916c4066f75179$var$TaggedMedia_codec = $0b916c4066f75179$var$include.codec;
var $0b916c4066f75179$export$5600df035d4a4579 = {
    source_toJson: $0b916c4066f75179$var$source_toJson,
    source_fromJson: $0b916c4066f75179$var$source_fromJson,
    displayType_toJson: $0b916c4066f75179$var$displayType_toJson,
    displayType_fromJson: $0b916c4066f75179$var$displayType_fromJson,
    imageFit_toJson: $0b916c4066f75179$var$imageFit_toJson,
    imageFit_fromJson: $0b916c4066f75179$var$imageFit_fromJson,
    toJson: $0b916c4066f75179$var$toJson,
    fromJson: $0b916c4066f75179$var$fromJson,
    t_encode: $0b916c4066f75179$var$TaggedMedia_t_encode,
    t_decode: $0b916c4066f75179$var$TaggedMedia_t_decode,
    codec: $0b916c4066f75179$var$TaggedMedia_codec
};
 /* source_fromJson Not a pure module */ 
});
parcelRegister("gZgAC", function(module, exports) {

$parcel$export(module.exports, "NodeBreakpoint", function () { return $c5df36311db42caa$export$72fda6e2106c3aee; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $fFzkv = parcelRequire("fFzkv");

var $doJJK = parcelRequire("doJJK");

var $fgjJY = parcelRequire("fgjJY");

var $bkHbG = parcelRequire("bkHbG");

var $cXBWA = parcelRequire("cXBWA");

var $3BXFF = parcelRequire("3BXFF");

var $7Qe3X = parcelRequire("7Qe3X");
function $c5df36311db42caa$var$node_encode(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "image",
            $jVmMx.Encode.nullable(param.image, $jVmMx.Encode.string)
        ],
        [
            "imageWidth",
            $jVmMx.Encode.nullable(param.imageWidth, $jVmMx.Encode.$$int)
        ],
        [
            "imageHeight",
            $jVmMx.Encode.nullable(param.imageHeight, $jVmMx.Encode.$$int)
        ],
        [
            "imageHotspots",
            $jVmMx.Encode.nullable(param.imageHotspots, function(__x) {
                return $iv6Yc._2($jVmMx.Encode.array, __x, $cXBWA.toJson);
            })
        ],
        [
            "video",
            $jVmMx.Encode.nullable(param.video, $jVmMx.Encode.string)
        ],
        [
            "layout",
            $jVmMx.Encode.nullable(param.layout, $bkHbG.Layout.toJson)
        ],
        [
            "cardShape",
            $jVmMx.Encode.nullable(param.cardShape, $3BXFF.CardShape.toJson)
        ],
        [
            "cardSize",
            $jVmMx.Encode.nullable(param.cardSize, $jVmMx.Encode.string)
        ],
        [
            "link",
            $jVmMx.Encode.nullable(param.link, $fgjJY.Link.toJson)
        ],
        [
            "sliderRows",
            $jVmMx.Encode.nullable(param.sliderRows, $jVmMx.Encode.$$int)
        ],
        [
            "gridMaxRows",
            $jVmMx.Encode.nullable(param.gridMaxRows, $jVmMx.Encode.$$int)
        ],
        [
            "googleFeedIds",
            $jVmMx.Encode.nullable(param.googleFeedIds, $7Qe3X.TaggedProducts.toJson)
        ],
        [
            "sectionTheme",
            $jVmMx.Encode.nullable(param.sectionTheme, $fFzkv.reference_toJson)
        ],
        [
            "pageTheme",
            $jVmMx.Encode.nullable(param.pageTheme, $fFzkv.reference_toJson)
        ]
    ]);
}
var $c5df36311db42caa$var$node_decode = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(id, image, imageWidth, imageHeight, imageHotspots, video, layout, cardShape, cardSize, link, sliderRows, gridMaxRows, googleFeedIds, sectionTheme, pageTheme) {
    return {
        id: id,
        image: image,
        imageWidth: imageWidth,
        imageHeight: imageHeight,
        imageHotspots: imageHotspots,
        video: video,
        layout: layout,
        cardShape: cardShape,
        cardSize: cardSize,
        link: link,
        sliderRows: sliderRows,
        gridMaxRows: gridMaxRows,
        googleFeedIds: googleFeedIds,
        sectionTheme: sectionTheme,
        pageTheme: pageTheme
    };
}), $jVmMx.Decode.fieldWithDefault("id", $jVmMx.Decode.string, "")), $iv6Yc._2($jVmMx.Decode.field, "image", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "imageWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $iv6Yc._2($jVmMx.Decode.field, "imageHeight", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $iv6Yc._2($jVmMx.Decode.field, "imageHotspots", $iv6Yc._1($jVmMx.Decode.option, $iv6Yc._1($jVmMx.Decode.array, $cXBWA.fromJson)))), $iv6Yc._2($jVmMx.Decode.field, "video", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "layout", $iv6Yc._1($jVmMx.Decode.option, $bkHbG.Layout.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "cardShape", $iv6Yc._1($jVmMx.Decode.option, $3BXFF.CardShape.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "cardSize", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $jVmMx.Decode.fieldWithDefault("link", $iv6Yc._1($jVmMx.Decode.option, $fgjJY.Link.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("sliderRows", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("gridMaxRows", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("googleFeedIds", $iv6Yc._1($jVmMx.Decode.option, $7Qe3X.TaggedProducts.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("sectionTheme", $iv6Yc._1($jVmMx.Decode.option, $fFzkv.reference_fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("pageTheme", $iv6Yc._1($jVmMx.Decode.option, $fFzkv.reference_fromJson), undefined));
var $c5df36311db42caa$var$fromJson = $79vie.map($79vie.field("mobile", $c5df36311db42caa$var$node_decode), function(mobile) {
    return {
        mobile: mobile
    };
});
function $c5df36311db42caa$var$toJson(param) {
    return $AAkl8.object([
        [
            "mobile",
            $c5df36311db42caa$var$node_encode(param.mobile)
        ]
    ]);
}
var $c5df36311db42caa$var$include = $doJJK.Make({
    toJson: $c5df36311db42caa$var$toJson,
    fromJson: $c5df36311db42caa$var$fromJson
});
var $c5df36311db42caa$var$NodeBreakpoint_empty = {
    mobile: {
        id: "",
        image: undefined,
        imageWidth: undefined,
        imageHeight: undefined,
        imageHotspots: undefined,
        video: undefined,
        layout: undefined,
        cardShape: undefined,
        cardSize: undefined,
        link: undefined,
        sliderRows: undefined,
        gridMaxRows: undefined,
        googleFeedIds: undefined,
        sectionTheme: undefined,
        pageTheme: undefined
    }
};
var $c5df36311db42caa$var$NodeBreakpoint_t_encode = $c5df36311db42caa$var$include.t_encode;
var $c5df36311db42caa$var$NodeBreakpoint_t_decode = $c5df36311db42caa$var$include.t_decode;
var $c5df36311db42caa$var$NodeBreakpoint_codec = $c5df36311db42caa$var$include.codec;
var $c5df36311db42caa$export$72fda6e2106c3aee = {
    node_encode: $c5df36311db42caa$var$node_encode,
    node_decode: $c5df36311db42caa$var$node_decode,
    fromJson: $c5df36311db42caa$var$fromJson,
    toJson: $c5df36311db42caa$var$toJson,
    empty: $c5df36311db42caa$var$NodeBreakpoint_empty,
    t_encode: $c5df36311db42caa$var$NodeBreakpoint_t_encode,
    t_decode: $c5df36311db42caa$var$NodeBreakpoint_t_decode,
    codec: $c5df36311db42caa$var$NodeBreakpoint_codec
};
 /* node_decode Not a pure module */ 
});
parcelRegister("fgjJY", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $b1c7a9b01cb1c470$export$a6c7ac8248d6e38a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $dRfYk = parcelRequire("dRfYk");

var $04dLg = parcelRequire("04dLg");
function $b1c7a9b01cb1c470$var$t_encode(v) {
    var categoryLink_toJson = function categoryLink_toJson(param) {
        return $iv6Yc._1($jVmMx.Encode.object, [
            [
                "value",
                $jVmMx.Encode.nullable(param.value, $jVmMx.Encode.string)
            ],
            [
                "categoryId",
                $iv6Yc._1($jVmMx.Encode.string, param.categoryId)
            ]
        ]);
    };
    var productLink_toJson = function productLink_toJson(param) {
        return $iv6Yc._1($jVmMx.Encode.object, [
            [
                "value",
                $jVmMx.Encode.nullable(param.value, $jVmMx.Encode.string)
            ],
            [
                "productId",
                $iv6Yc._1($jVmMx.Encode.string, param.productId)
            ],
            [
                "variantId",
                $jVmMx.Encode.nullable(param.variantId, $jVmMx.Encode.string)
            ]
        ]);
    };
    var storeCollectionLink_toJson = function storeCollectionLink_toJson(param) {
        return $iv6Yc._1($jVmMx.Encode.object, [
            [
                "value",
                $jVmMx.Encode.nullable(param.value, $jVmMx.Encode.string)
            ],
            [
                "categoryId",
                $iv6Yc._1($jVmMx.Encode.string, param.categoryId)
            ],
            [
                "sortBy",
                $04dLg.ProductSortOrder.toJson(param.sortBy)
            ]
        ]);
    };
    var customActionLink_toJson = function customActionLink_toJson(param) {
        return $iv6Yc._1($jVmMx.Encode.object, [
            [
                "customActionId",
                $iv6Yc._1($dRfYk.toJson, param.customActionId)
            ]
        ]);
    };
    if (typeof v === "number") return $jVmMx.Encode.simpleVariant([
        [
            "NotLinked",
            /* NotLinked */ 0
        ]
    ], /* NotLinked */ 0);
    switch(v.TAG | 0){
        case /* UrlLink */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "UrlLink", $jVmMx.Encode.string);
        case /* CategoryLink */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "CategoryLink", categoryLink_toJson);
        case /* ProductLink */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ProductLink", productLink_toJson);
        case /* StoreCategoryLink */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "StoreCategoryLink", storeCollectionLink_toJson);
        case /* CustomActionLink */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "CustomActionLink", customActionLink_toJson);
        case /* UnknownLink */ 5:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "UnknownLink", $jVmMx.Encode.string);
    }
}
var $b1c7a9b01cb1c470$var$categoryLink_fromJson = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "value", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "categoryId", $jVmMx.Decode.string), function(value, categoryId) {
    return {
        value: value,
        categoryId: categoryId
    };
});
var $b1c7a9b01cb1c470$var$productLink_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "value", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "productId", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "variantId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), function(value, productId, variantId) {
    return {
        value: value,
        productId: productId,
        variantId: variantId
    };
});
var $b1c7a9b01cb1c470$var$storeCategoryLink_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "value", $iv6Yc._1($jVmMx.Decode.nullable, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "categoryId", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("sortBy", $04dLg.ProductSortOrder.fromJson, /* Default */ 0), function(value, categoryId, sortBy) {
    return {
        value: value,
        categoryId: categoryId,
        sortBy: sortBy
    };
});
var $b1c7a9b01cb1c470$var$customActionLink_fromJson = $iv6Yc._2($jVmMx.Decode.map, $iv6Yc._2($jVmMx.Decode.field, "customActionId", $dRfYk.fromJson), function(customActionId) {
    return {
        customActionId: customActionId
    };
});
var $b1c7a9b01cb1c470$var$t_decode = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("UnknownLink", $jVmMx.Decode.string, function(str) {
    return {
        TAG: /* UnknownLink */ 5,
        _0: str
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("UrlLink", $jVmMx.Decode.string, function(str) {
        return {
            TAG: /* UrlLink */ 0,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("CategoryLink", $b1c7a9b01cb1c470$var$categoryLink_fromJson, function(str) {
        return {
            TAG: /* CategoryLink */ 1,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("ProductLink", $b1c7a9b01cb1c470$var$productLink_fromJson, function(str) {
        return {
            TAG: /* ProductLink */ 2,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("StoreCategoryLink", $b1c7a9b01cb1c470$var$storeCategoryLink_fromJson, function(str) {
        return {
            TAG: /* StoreCategoryLink */ 3,
            _0: str
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("CustomActionLink", $b1c7a9b01cb1c470$var$customActionLink_fromJson, function(str) {
        return {
            TAG: /* CustomActionLink */ 4,
            _0: str
        };
    }),
    $jVmMx.Decode.simpleVariant([
        [
            "NotLinked",
            /* NotLinked */ 0
        ]
    ])
]);
var $b1c7a9b01cb1c470$var$t_v1_decode = $iv6Yc._2($jVmMx.Decode.andThen, $jVmMx.Decode.$$default($jVmMx.Decode.string, ""), function(link) {
    return $iv6Yc._1($jVmMx.Decode.succeed, {
        TAG: /* UnknownLink */ 5,
        _0: link
    });
});
var $b1c7a9b01cb1c470$var$t_decode$1 = $79vie.oneOf($b1c7a9b01cb1c470$var$t_decode, [
    $b1c7a9b01cb1c470$var$t_v1_decode
]);
var $b1c7a9b01cb1c470$var$include = $doJJK.Make({
    toJson: $b1c7a9b01cb1c470$var$t_encode,
    fromJson: $b1c7a9b01cb1c470$var$t_decode$1
});
var $b1c7a9b01cb1c470$var$Link_t_encode = $b1c7a9b01cb1c470$var$include.t_encode;
var $b1c7a9b01cb1c470$var$Link_t_decode = $b1c7a9b01cb1c470$var$include.t_decode;
var $b1c7a9b01cb1c470$var$Link_codec = $b1c7a9b01cb1c470$var$include.codec;
var $b1c7a9b01cb1c470$export$a6c7ac8248d6e38a = {
    t_v1_decode: $b1c7a9b01cb1c470$var$t_v1_decode,
    toJson: $b1c7a9b01cb1c470$var$t_encode,
    fromJson: $b1c7a9b01cb1c470$var$t_decode$1,
    t_encode: $b1c7a9b01cb1c470$var$Link_t_encode,
    t_decode: $b1c7a9b01cb1c470$var$Link_t_decode,
    codec: $b1c7a9b01cb1c470$var$Link_codec
};
 /* categoryLink_fromJson Not a pure module */ 
});

parcelRegister("bkHbG", function(module, exports) {

$parcel$export(module.exports, "Layout", function () { return $8403101541d24caa$export$c84671f46d6a1ca; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $8403101541d24caa$var$partial_arg = [
    [
        "Default",
        /* Default */ 0
    ],
    [
        "Slider",
        /* Slider */ 1
    ],
    [
        "Grid",
        /* Grid */ 2
    ],
    [
        "AdvancedGrid",
        /* AdvancedGrid */ 3
    ],
    [
        "AdvancedSlider",
        /* AdvancedSlider */ 4
    ]
];
function $8403101541d24caa$var$labels_encode(param) {
    return $jVmMx.Encode.simpleVariant($8403101541d24caa$var$partial_arg, param);
}
var $8403101541d24caa$var$labels_decode = $jVmMx.Decode.simpleVariant([
    [
        "Default",
        /* Default */ 0
    ],
    [
        "Slider",
        /* Slider */ 1
    ],
    [
        "Grid",
        /* Grid */ 2
    ],
    [
        "AdvancedGrid",
        /* AdvancedGrid */ 3
    ],
    [
        "AdvancedSlider",
        /* AdvancedSlider */ 4
    ]
]);
var $8403101541d24caa$var$cellContent_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Slot",
        /* Slot */ 0
    ],
    [
        "Whitespace",
        /* Whitespace */ 1
    ]
]);
var $8403101541d24caa$var$partial_arg$1 = [
    [
        "Slot",
        /* Slot */ 0
    ],
    [
        "Whitespace",
        /* Whitespace */ 1
    ]
];
function $8403101541d24caa$var$cellContent_toJson(param) {
    return $jVmMx.Encode.simpleVariant($8403101541d24caa$var$partial_arg$1, param);
}
function $8403101541d24caa$var$cell_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "colSpan",
            $iv6Yc._1($jVmMx.Encode.$$int, param.colSpan)
        ],
        [
            "rowSpan",
            $iv6Yc._1($jVmMx.Encode.$$int, param.rowSpan)
        ],
        [
            "content",
            $iv6Yc._1($8403101541d24caa$var$cellContent_toJson, param.content)
        ]
    ]);
}
var $8403101541d24caa$var$cell_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "colSpan", $jVmMx.Decode.$$int), $iv6Yc._2($jVmMx.Decode.field, "rowSpan", $jVmMx.Decode.$$int), $iv6Yc._2($jVmMx.Decode.field, "content", $8403101541d24caa$var$cellContent_fromJson), function(colSpan, rowSpan, content) {
    return {
        colSpan: colSpan,
        rowSpan: rowSpan,
        content: content
    };
});
function $8403101541d24caa$var$toJson(__x) {
    return $iv6Yc._2($jVmMx.Encode.array, __x, function(__x) {
        return $iv6Yc._2($jVmMx.Encode.array, __x, $8403101541d24caa$var$cell_toJson);
    });
}
var $8403101541d24caa$var$fromJson = $iv6Yc._1($jVmMx.Decode.array, $iv6Yc._1($jVmMx.Decode.array, $8403101541d24caa$var$cell_fromJson));
var $8403101541d24caa$var$GridPattern = {
    cellContent_fromJson: $8403101541d24caa$var$cellContent_fromJson,
    cellContent_toJson: $8403101541d24caa$var$cellContent_toJson,
    cell_toJson: $8403101541d24caa$var$cell_toJson,
    cell_fromJson: $8403101541d24caa$var$cell_fromJson,
    toJson: $8403101541d24caa$var$toJson,
    fromJson: $8403101541d24caa$var$fromJson
};
function $8403101541d24caa$var$gridOptions_encode(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "columns",
            $jVmMx.Encode.nullable(param.columns, $jVmMx.Encode.$$int)
        ],
        [
            "gap",
            $jVmMx.Encode.nullable(param.gap, $jVmMx.Encode.$$int)
        ],
        [
            "maxWidth",
            $jVmMx.Encode.nullable(param.maxWidth, $jVmMx.Encode.$$int)
        ],
        [
            "padding",
            $jVmMx.Encode.nullable(param.padding, $jVmMx.Encode.$$int)
        ]
    ]);
}
var $8403101541d24caa$var$gridOptions_decode = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "columns", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int)), $iv6Yc._2($jVmMx.Decode.field, "gap", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int)), $iv6Yc._2($jVmMx.Decode.field, "maxWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int)), $iv6Yc._2($jVmMx.Decode.field, "padding", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int)), function(cols, gap, maxWidth, padding) {
    return {
        columns: cols,
        gap: gap,
        maxWidth: maxWidth,
        padding: padding
    };
});
var $8403101541d24caa$var$partial_arg$2 = [
    [
        "EffectSlide",
        /* EffectSlide */ 0
    ],
    [
        "EffectFade",
        /* EffectFade */ 1
    ]
];
function $8403101541d24caa$var$sliderEffect_encode(param) {
    return $jVmMx.Encode.simpleVariant($8403101541d24caa$var$partial_arg$2, param);
}
var $8403101541d24caa$var$sliderEffect_decode = $jVmMx.Decode.simpleVariant([
    [
        "EffectSlide",
        /* EffectSlide */ 0
    ],
    [
        "EffectFade",
        /* EffectFade */ 1
    ]
]);
var $8403101541d24caa$var$partial_arg$3 = [
    [
        "NavAuto",
        /* NavAuto */ 0
    ],
    [
        "NavScrollbar",
        /* NavScrollbar */ 2
    ],
    [
        "NavArrows",
        /* NavArrows */ 1
    ],
    [
        "NavDots",
        /* NavDots */ 3
    ],
    [
        "NavNone",
        /* NavNone */ 4
    ]
];
function $8403101541d24caa$var$sliderNav_encode(param) {
    return $jVmMx.Encode.simpleVariant($8403101541d24caa$var$partial_arg$3, param);
}
var $8403101541d24caa$var$sliderNav_decode = $jVmMx.Decode.simpleVariant([
    [
        "NavAuto",
        /* NavAuto */ 0
    ],
    [
        "NavScrollbar",
        /* NavScrollbar */ 2
    ],
    [
        "NavArrows",
        /* NavArrows */ 1
    ],
    [
        "NavDots",
        /* NavDots */ 3
    ],
    [
        "NavNone",
        /* NavNone */ 4
    ]
]);
var $8403101541d24caa$var$partial_arg$4 = [
    [
        "TransitionEase",
        /* TransitionEase */ 0
    ],
    [
        "TransitionLinear",
        /* TransitionLinear */ 1
    ],
    [
        "TransitionEaseIn",
        /* TransitionEaseIn */ 2
    ],
    [
        "TransitionEaseOut",
        /* TransitionEaseOut */ 3
    ],
    [
        "TransitionEaseInOut",
        /* TransitionEaseInOut */ 4
    ]
];
function $8403101541d24caa$var$transition_encode(param) {
    return $jVmMx.Encode.simpleVariant($8403101541d24caa$var$partial_arg$4, param);
}
var $8403101541d24caa$var$transition_decode = $jVmMx.Decode.simpleVariant([
    [
        "TransitionEase",
        /* TransitionEase */ 0
    ],
    [
        "TransitionLinear",
        /* TransitionLinear */ 1
    ],
    [
        "TransitionEaseIn",
        /* TransitionEaseIn */ 2
    ],
    [
        "TransitionEaseOut",
        /* TransitionEaseOut */ 3
    ],
    [
        "TransitionEaseInOut",
        /* TransitionEaseInOut */ 4
    ]
]);
function $8403101541d24caa$var$sliderOptions_encode(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "columns",
            $jVmMx.Encode.nullable(param.columns, $jVmMx.Encode.$$float)
        ],
        [
            "gap",
            $jVmMx.Encode.nullable(param.gap, $jVmMx.Encode.$$int)
        ],
        [
            "maxWidth",
            $jVmMx.Encode.nullable(param.maxWidth, $jVmMx.Encode.$$int)
        ],
        [
            "padding",
            $jVmMx.Encode.nullable(param.padding, $jVmMx.Encode.$$int)
        ],
        [
            "effect",
            $iv6Yc._1($8403101541d24caa$var$sliderEffect_encode, param.effect)
        ],
        [
            "nav",
            $iv6Yc._1($8403101541d24caa$var$sliderNav_encode, param.nav)
        ],
        [
            "autoplay",
            $iv6Yc._1($jVmMx.Encode.bool, param.autoplay)
        ],
        [
            "transition",
            $iv6Yc._1($8403101541d24caa$var$transition_encode, param.transition)
        ],
        [
            "transitionSpeed",
            $iv6Yc._1($jVmMx.Encode.$$int, param.transitionSpeed)
        ],
        [
            "autoplayDelay",
            $iv6Yc._1($jVmMx.Encode.$$int, param.autoplayDelay)
        ]
    ]);
}
var $8403101541d24caa$var$sliderOptions_decode = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(columns, gap, maxWidth, padding, effect, nav, transition, transitionSpeed, autoplay, autoplayDelay, loop) {
    return {
        columns: columns,
        gap: gap,
        maxWidth: maxWidth,
        padding: padding,
        effect: effect,
        nav: nav,
        loop: loop,
        autoplay: autoplay,
        transition: transition,
        transitionSpeed: transitionSpeed,
        autoplayDelay: autoplayDelay
    };
}), $iv6Yc._2($jVmMx.Decode.field, "columns", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$float))), $iv6Yc._2($jVmMx.Decode.field, "gap", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $iv6Yc._2($jVmMx.Decode.field, "maxWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $iv6Yc._2($jVmMx.Decode.field, "padding", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $iv6Yc._2($jVmMx.Decode.field, "effect", $8403101541d24caa$var$sliderEffect_decode)), $jVmMx.Decode.fieldWithDefault("nav", $8403101541d24caa$var$sliderNav_decode, /* NavAuto */ 0)), $jVmMx.Decode.fieldWithDefault("transition", $8403101541d24caa$var$transition_decode, /* TransitionEaseOut */ 3)), $jVmMx.Decode.fieldWithDefault("transitionSpeed", $jVmMx.Decode.$$int, 300)), $jVmMx.Decode.fieldWithDefault("autoplay", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("autoplayDelay", $jVmMx.Decode.$$int, 3000)), $jVmMx.Decode.fieldWithDefault("loop", $jVmMx.Decode.bool, false));
function $8403101541d24caa$var$toJson$1(layout) {
    if (typeof layout !== "number") {
        if (layout.TAG === /* AdvancedGrid */ 0) return $AAkl8.string("AdvancedGrid" + $AAkl8.encode($8403101541d24caa$var$gridOptions_encode(layout._0), 0));
        else return $AAkl8.string("AdvancedSlider" + $AAkl8.encode($8403101541d24caa$var$sliderOptions_encode(layout._0), 0));
    }
    switch(layout){
        case /* Default */ 0:
            return $AAkl8.string("default");
        case /* Slider */ 1:
            return $AAkl8.string("slider");
        case /* Grid */ 2:
            return $AAkl8.string("grid");
    }
}
var $8403101541d24caa$var$advancedGrid_decode = $jVmMx.Decode.stringifiedPayloadVariant("AdvancedGrid", $8403101541d24caa$var$gridOptions_decode, function(payload) {
    return {
        TAG: /* AdvancedGrid */ 0,
        _0: payload
    };
});
var $8403101541d24caa$var$advancedSlider_decode = $jVmMx.Decode.stringifiedPayloadVariant("AdvancedSlider", $8403101541d24caa$var$sliderOptions_decode, function(payload) {
    return {
        TAG: /* AdvancedSlider */ 1,
        _0: payload
    };
});
var $8403101541d24caa$var$fromJson$1 = $iv6Yc._2($jVmMx.Decode.oneOf, $8403101541d24caa$var$advancedGrid_decode, [
    $8403101541d24caa$var$advancedSlider_decode,
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("grid"), function(param) {
        return /* Grid */ 2;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("slider"), function(param) {
        return /* Slider */ 1;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("default"), function(param) {
        return /* Default */ 0;
    })
]);
var $8403101541d24caa$var$include = $doJJK.Make({
    toJson: $8403101541d24caa$var$toJson$1,
    fromJson: $8403101541d24caa$var$fromJson$1
});
var $8403101541d24caa$var$Layout_t_encode = $8403101541d24caa$var$include.t_encode;
var $8403101541d24caa$var$Layout_t_decode = $8403101541d24caa$var$include.t_decode;
var $8403101541d24caa$var$Layout_codec = $8403101541d24caa$var$include.codec;
var $8403101541d24caa$export$c84671f46d6a1ca = {
    labels_encode: $8403101541d24caa$var$labels_encode,
    labels_decode: $8403101541d24caa$var$labels_decode,
    abstract_encode: $AAkl8.string,
    abstract_decode: $79vie.string,
    GridPattern: $8403101541d24caa$var$GridPattern,
    gridOptions_encode: $8403101541d24caa$var$gridOptions_encode,
    gridOptions_decode: $8403101541d24caa$var$gridOptions_decode,
    sliderEffect_encode: $8403101541d24caa$var$sliderEffect_encode,
    sliderEffect_decode: $8403101541d24caa$var$sliderEffect_decode,
    sliderNav_encode: $8403101541d24caa$var$sliderNav_encode,
    sliderNav_decode: $8403101541d24caa$var$sliderNav_decode,
    transition_encode: $8403101541d24caa$var$transition_encode,
    transition_decode: $8403101541d24caa$var$transition_decode,
    sliderOptions_encode: $8403101541d24caa$var$sliderOptions_encode,
    sliderOptions_decode: $8403101541d24caa$var$sliderOptions_decode,
    toJson: $8403101541d24caa$var$toJson$1,
    advancedGrid_decode: $8403101541d24caa$var$advancedGrid_decode,
    advancedSlider_decode: $8403101541d24caa$var$advancedSlider_decode,
    fromJson: $8403101541d24caa$var$fromJson$1,
    t_encode: $8403101541d24caa$var$Layout_t_encode,
    t_decode: $8403101541d24caa$var$Layout_t_decode,
    codec: $8403101541d24caa$var$Layout_codec
};
 /* labels_decode Not a pure module */ 
});

parcelRegister("3BXFF", function(module, exports) {

$parcel$export(module.exports, "CardShape", function () { return $2a131d3950bcab33$export$4932b1a0b24cac6d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $2a131d3950bcab33$var$partial_arg = [
    [
        "Default",
        /* Default */ 0
    ],
    [
        "Landscape",
        /* Landscape */ 1
    ],
    [
        "Portrait",
        /* Portrait */ 2
    ],
    [
        "Panorama",
        /* Panorama */ 3
    ],
    [
        "Wide",
        /* Wide */ 4
    ],
    [
        "Tall",
        /* Tall */ 5
    ],
    [
        "Square",
        /* Square */ 6
    ],
    [
        "Circle",
        /* Circle */ 7
    ],
    [
        "Custom",
        /* Custom */ 8
    ]
];
function $2a131d3950bcab33$var$labels_encode(param) {
    return $jVmMx.Encode.simpleVariant($2a131d3950bcab33$var$partial_arg, param);
}
var $2a131d3950bcab33$var$labels_decode = $jVmMx.Decode.simpleVariant([
    [
        "Default",
        /* Default */ 0
    ],
    [
        "Landscape",
        /* Landscape */ 1
    ],
    [
        "Portrait",
        /* Portrait */ 2
    ],
    [
        "Panorama",
        /* Panorama */ 3
    ],
    [
        "Wide",
        /* Wide */ 4
    ],
    [
        "Tall",
        /* Tall */ 5
    ],
    [
        "Square",
        /* Square */ 6
    ],
    [
        "Circle",
        /* Circle */ 7
    ],
    [
        "Custom",
        /* Custom */ 8
    ]
]);
function $2a131d3950bcab33$var$custom_encode(c) {
    return $AAkl8.object([
        [
            "width",
            $AAkl8.$$int(c.width)
        ],
        [
            "height",
            $AAkl8.$$int(c.height)
        ]
    ]);
}
var $2a131d3950bcab33$var$custom_decode = $79vie.map2($79vie.field("width", $79vie.$$int), $79vie.field("height", $79vie.$$int), function(width, height) {
    return {
        width: width,
        height: height
    };
});
function $2a131d3950bcab33$var$toJson(cardShape) {
    if (typeof cardShape !== "number") return $iv6Yc._1($jVmMx.Encode.string, "Custom" + $iv6Yc._2($jVmMx.Encode.encode, $2a131d3950bcab33$var$custom_encode(cardShape._0), 0));
    switch(cardShape){
        case /* Default */ 0:
            return $iv6Yc._1($jVmMx.Encode.string, "default");
        case /* Landscape */ 1:
            return $iv6Yc._1($jVmMx.Encode.string, "landscape");
        case /* Portrait */ 2:
            return $iv6Yc._1($jVmMx.Encode.string, "portrait");
        case /* Panorama */ 3:
            return $iv6Yc._1($jVmMx.Encode.string, "panorama");
        case /* Wide */ 4:
            return $iv6Yc._1($jVmMx.Encode.string, "wide");
        case /* Tall */ 5:
            return $iv6Yc._1($jVmMx.Encode.string, "tall");
        case /* Square */ 6:
            return $iv6Yc._1($jVmMx.Encode.string, "square");
        case /* Circle */ 7:
            return $iv6Yc._1($jVmMx.Encode.string, "circle");
    }
}
var $2a131d3950bcab33$var$customDecode = $jVmMx.Decode.stringifiedPayloadVariant("Custom", $2a131d3950bcab33$var$custom_decode, function(payload) {
    return /* Custom */ {
        _0: payload
    };
});
var $2a131d3950bcab33$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $2a131d3950bcab33$var$customDecode, [
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("default"), function(param) {
        return /* Default */ 0;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("landscape"), function(param) {
        return /* Landscape */ 1;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("portrait"), function(param) {
        return /* Portrait */ 2;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("panorama"), function(param) {
        return /* Panorama */ 3;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("wide"), function(param) {
        return /* Wide */ 4;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("tall"), function(param) {
        return /* Tall */ 5;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("square"), function(param) {
        return /* Square */ 6;
    }),
    $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.exactString("circle"), function(param) {
        return /* Circle */ 7;
    })
]);
var $2a131d3950bcab33$var$include = $doJJK.Make({
    toJson: $2a131d3950bcab33$var$toJson,
    fromJson: $2a131d3950bcab33$var$fromJson
});
var $2a131d3950bcab33$var$CardShape_t_encode = $2a131d3950bcab33$var$include.t_encode;
var $2a131d3950bcab33$var$CardShape_t_decode = $2a131d3950bcab33$var$include.t_decode;
var $2a131d3950bcab33$var$CardShape_codec = $2a131d3950bcab33$var$include.codec;
var $2a131d3950bcab33$export$4932b1a0b24cac6d = {
    labels_encode: $2a131d3950bcab33$var$labels_encode,
    labels_decode: $2a131d3950bcab33$var$labels_decode,
    abstract_encode: $AAkl8.string,
    abstract_decode: $79vie.string,
    custom_encode: $2a131d3950bcab33$var$custom_encode,
    custom_decode: $2a131d3950bcab33$var$custom_decode,
    toJson: $2a131d3950bcab33$var$toJson,
    fromJson: $2a131d3950bcab33$var$fromJson,
    t_encode: $2a131d3950bcab33$var$CardShape_t_encode,
    t_decode: $2a131d3950bcab33$var$CardShape_t_decode,
    codec: $2a131d3950bcab33$var$CardShape_codec
};
 /* labels_decode Not a pure module */ 
});

parcelRegister("7Qe3X", function(module, exports) {

$parcel$export(module.exports, "TaggedProducts", function () { return $5b584c4b6d1bb7db$export$830cc7a486eaf924; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $5b584c4b6d1bb7db$var$entry_encode(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "productId",
            $iv6Yc._1($jVmMx.Encode.string, param.productId)
        ],
        [
            "variantId",
            $jVmMx.Encode.nullable(param.variantId, $jVmMx.Encode.string)
        ]
    ]);
}
var $5b584c4b6d1bb7db$var$entry_v1_decode = $iv6Yc._2($jVmMx.Decode.andThen, $jVmMx.Decode.$$default($jVmMx.Decode.string, ""), function(entry) {
    return $iv6Yc._1($jVmMx.Decode.succeed, {
        id: entry,
        productId: entry,
        variantId: undefined
    });
});
var $5b584c4b6d1bb7db$var$entry_decode = $79vie.map3($79vie.field("id", $79vie.string), $79vie.field("productId", $79vie.string), $79vie.field("variantId", $79vie.option($79vie.string)), function(id, productId, variantId) {
    return {
        id: id,
        productId: productId,
        variantId: variantId
    };
});
var $5b584c4b6d1bb7db$var$entry_decode$1 = $79vie.oneOf($5b584c4b6d1bb7db$var$entry_decode, [
    $5b584c4b6d1bb7db$var$entry_v1_decode
]);
function $5b584c4b6d1bb7db$var$toJson(arr) {
    return $AAkl8.array(arr, $5b584c4b6d1bb7db$var$entry_encode);
}
var $5b584c4b6d1bb7db$var$fromJson = $79vie.array($79vie.oneOf($5b584c4b6d1bb7db$var$entry_decode$1, [
    $5b584c4b6d1bb7db$var$entry_v1_decode
]));
var $5b584c4b6d1bb7db$var$include = $doJJK.Make({
    toJson: $5b584c4b6d1bb7db$var$toJson,
    fromJson: $5b584c4b6d1bb7db$var$fromJson
});
var $5b584c4b6d1bb7db$var$TaggedProducts_t_encode = $5b584c4b6d1bb7db$var$include.t_encode;
var $5b584c4b6d1bb7db$var$TaggedProducts_t_decode = $5b584c4b6d1bb7db$var$include.t_decode;
var $5b584c4b6d1bb7db$var$TaggedProducts_codec = $5b584c4b6d1bb7db$var$include.codec;
var $5b584c4b6d1bb7db$export$830cc7a486eaf924 = {
    entry_encode: $5b584c4b6d1bb7db$var$entry_encode,
    entry_v1_decode: $5b584c4b6d1bb7db$var$entry_v1_decode,
    entry_decode: $5b584c4b6d1bb7db$var$entry_decode$1,
    toJson: $5b584c4b6d1bb7db$var$toJson,
    fromJson: $5b584c4b6d1bb7db$var$fromJson,
    t_encode: $5b584c4b6d1bb7db$var$TaggedProducts_t_encode,
    t_decode: $5b584c4b6d1bb7db$var$TaggedProducts_t_decode,
    codec: $5b584c4b6d1bb7db$var$TaggedProducts_codec
};
 /* entry_v1_decode Not a pure module */ 
});



parcelRegister("5lwUf", function(module, exports) {

$parcel$export(module.exports, "DisplayPriority", function () { return $3e487064e461ee0c$export$685054b2bd85bd7a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $3e487064e461ee0c$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "ChildrenFirst",
        /* ChildrenFirst */ 0
    ],
    [
        "ProductsFirst",
        /* ProductsFirst */ 1
    ]
]);
function $3e487064e461ee0c$var$toJson(v) {
    if (v) return $iv6Yc._2($jVmMx.Encode.array, [
        "ProductsFirst"
    ], $jVmMx.Encode.string);
    else return $iv6Yc._2($jVmMx.Encode.array, [
        "ChildrenFirst"
    ], $jVmMx.Encode.string);
}
var $3e487064e461ee0c$var$include = $doJJK.Make({
    toJson: $3e487064e461ee0c$var$toJson,
    fromJson: $3e487064e461ee0c$var$fromJson
});
var $3e487064e461ee0c$var$DisplayPriority_t_encode = $3e487064e461ee0c$var$include.t_encode;
var $3e487064e461ee0c$var$DisplayPriority_t_decode = $3e487064e461ee0c$var$include.t_decode;
var $3e487064e461ee0c$var$DisplayPriority_codec = $3e487064e461ee0c$var$include.codec;
var $3e487064e461ee0c$export$685054b2bd85bd7a = {
    fromJson: $3e487064e461ee0c$var$fromJson,
    toJson: $3e487064e461ee0c$var$toJson,
    t_encode: $3e487064e461ee0c$var$DisplayPriority_t_encode,
    t_decode: $3e487064e461ee0c$var$DisplayPriority_t_decode,
    codec: $3e487064e461ee0c$var$DisplayPriority_codec
};
 /* fromJson Not a pure module */ 
});

parcelRegister("fnO65", function(module, exports) {

$parcel$export(module.exports, "CategoryTabSettings", function () { return $b32fdd3eabce53a3$export$96682b7d1b581f55; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $b32fdd3eabce53a3$var$partial_arg = [
    [
        "Labels",
        /* Labels */ 0
    ],
    [
        "PillsWithLabel",
        /* PillsWithLabel */ 1
    ],
    [
        "PillsWithIcon",
        /* PillsWithIcon */ 2
    ],
    [
        "PillsWithRoundedIcon",
        /* PillsWithRoundedIcon */ 3
    ]
];
function $b32fdd3eabce53a3$var$layout_encode(param) {
    return $jVmMx.Encode.simpleVariant($b32fdd3eabce53a3$var$partial_arg, param);
}
var $b32fdd3eabce53a3$var$layout_decode = $jVmMx.Decode.simpleVariant([
    [
        "Labels",
        /* Labels */ 0
    ],
    [
        "PillsWithLabel",
        /* PillsWithLabel */ 1
    ],
    [
        "PillsWithIcon",
        /* PillsWithIcon */ 2
    ],
    [
        "PillsWithRoundedIcon",
        /* PillsWithRoundedIcon */ 3
    ]
]);
var $b32fdd3eabce53a3$var$partial_arg$1 = [
    [
        "Small",
        /* Small */ 0
    ],
    [
        "Medium",
        /* Medium */ 1
    ],
    [
        "Large",
        /* Large */ 2
    ]
];
function $b32fdd3eabce53a3$var$size_encode(param) {
    return $jVmMx.Encode.simpleVariant($b32fdd3eabce53a3$var$partial_arg$1, param);
}
var $b32fdd3eabce53a3$var$size_decode = $jVmMx.Decode.simpleVariant([
    [
        "Small",
        /* Small */ 0
    ],
    [
        "Medium",
        /* Medium */ 1
    ],
    [
        "Large",
        /* Large */ 2
    ]
]);
var $b32fdd3eabce53a3$var$partial_arg$2 = [
    [
        "Top",
        /* Top */ 0
    ],
    [
        "Bottom",
        /* Bottom */ 1
    ]
];
function $b32fdd3eabce53a3$var$position_encode(param) {
    return $jVmMx.Encode.simpleVariant($b32fdd3eabce53a3$var$partial_arg$2, param);
}
var $b32fdd3eabce53a3$var$position_decode = $jVmMx.Decode.simpleVariant([
    [
        "Top",
        /* Top */ 0
    ],
    [
        "Bottom",
        /* Bottom */ 1
    ]
]);
var $b32fdd3eabce53a3$var$partial_arg$3 = [
    [
        "Left",
        /* Left */ 0
    ],
    [
        "Center",
        /* Center */ 1
    ],
    [
        "Right",
        /* Right */ 2
    ]
];
function $b32fdd3eabce53a3$var$align_encode(param) {
    return $jVmMx.Encode.simpleVariant($b32fdd3eabce53a3$var$partial_arg$3, param);
}
var $b32fdd3eabce53a3$var$align_decode = $jVmMx.Decode.simpleVariant([
    [
        "Left",
        /* Left */ 0
    ],
    [
        "Center",
        /* Center */ 1
    ],
    [
        "Right",
        /* Right */ 2
    ]
]);
function $b32fdd3eabce53a3$var$toJson(param) {
    return $AAkl8.object([
        [
            "layout",
            $iv6Yc._1($b32fdd3eabce53a3$var$layout_encode, param.layout)
        ],
        [
            "size",
            $iv6Yc._1($b32fdd3eabce53a3$var$size_encode, param.size)
        ],
        [
            "position",
            $iv6Yc._1($b32fdd3eabce53a3$var$position_encode, param.position)
        ],
        [
            "align",
            $iv6Yc._1($b32fdd3eabce53a3$var$align_encode, param.align)
        ]
    ]);
}
var $b32fdd3eabce53a3$var$fromJson = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "layout", $iv6Yc._1($jVmMx.Decode.option, $b32fdd3eabce53a3$var$layout_decode)), $iv6Yc._2($jVmMx.Decode.field, "size", $iv6Yc._1($jVmMx.Decode.option, $b32fdd3eabce53a3$var$size_decode)), $iv6Yc._2($jVmMx.Decode.field, "position", $iv6Yc._1($jVmMx.Decode.option, $b32fdd3eabce53a3$var$position_decode)), $iv6Yc._2($jVmMx.Decode.field, "align", $iv6Yc._1($jVmMx.Decode.option, $b32fdd3eabce53a3$var$align_decode)), function(layout, size, position, align) {
    return {
        layout: $2whNH.getWithDefault(layout, /* Labels */ 0),
        size: $2whNH.getWithDefault(size, /* Medium */ 1),
        position: $2whNH.getWithDefault(position, /* Top */ 0),
        align: $2whNH.getWithDefault(align, /* Left */ 0)
    };
});
var $b32fdd3eabce53a3$var$include = $doJJK.Make({
    toJson: $b32fdd3eabce53a3$var$toJson,
    fromJson: $b32fdd3eabce53a3$var$fromJson
});
var $b32fdd3eabce53a3$var$CategoryTabSettings_t_encode = $b32fdd3eabce53a3$var$include.t_encode;
var $b32fdd3eabce53a3$var$CategoryTabSettings_t_decode = $b32fdd3eabce53a3$var$include.t_decode;
var $b32fdd3eabce53a3$var$CategoryTabSettings_codec = $b32fdd3eabce53a3$var$include.codec;
var $b32fdd3eabce53a3$export$96682b7d1b581f55 = {
    layout_encode: $b32fdd3eabce53a3$var$layout_encode,
    layout_decode: $b32fdd3eabce53a3$var$layout_decode,
    size_encode: $b32fdd3eabce53a3$var$size_encode,
    size_decode: $b32fdd3eabce53a3$var$size_decode,
    position_encode: $b32fdd3eabce53a3$var$position_encode,
    position_decode: $b32fdd3eabce53a3$var$position_decode,
    align_encode: $b32fdd3eabce53a3$var$align_encode,
    align_decode: $b32fdd3eabce53a3$var$align_decode,
    toJson: $b32fdd3eabce53a3$var$toJson,
    fromJson: $b32fdd3eabce53a3$var$fromJson,
    t_encode: $b32fdd3eabce53a3$var$CategoryTabSettings_t_encode,
    t_decode: $b32fdd3eabce53a3$var$CategoryTabSettings_t_decode,
    codec: $b32fdd3eabce53a3$var$CategoryTabSettings_codec
};
 /* layout_decode Not a pure module */ 
});

parcelRegister("cvFfT", function(module, exports) {

$parcel$export(module.exports, "SocialNetworkSource", function () { return $91b861c0b6c61b13$export$1daf4b0130eb169c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $j1laG = parcelRequire("j1laG");

var $eIysb = parcelRequire("eIysb");
var $91b861c0b6c61b13$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Instagram", $eIysb.ContentType.fromJson, function(payload) {
    return {
        TAG: /* Instagram */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Tiktok", $j1laG.ContentType.fromJson, function(payload) {
        return {
            TAG: /* Tiktok */ 1,
            _0: payload
        };
    })
]);
function $91b861c0b6c61b13$var$toJson(source) {
    if (source.TAG === /* Instagram */ 0) return $jVmMx.Encode.deccoVariantWithPayload(source._0, "Instagram", $eIysb.ContentType.toJson);
    else return $jVmMx.Encode.deccoVariantWithPayload(source._0, "Tiktok", $j1laG.ContentType.toJson);
}
var $91b861c0b6c61b13$var$include = $doJJK.Make({
    toJson: $91b861c0b6c61b13$var$toJson,
    fromJson: $91b861c0b6c61b13$var$fromJson
});
var $91b861c0b6c61b13$var$t_encode = $91b861c0b6c61b13$var$include.t_encode;
var $91b861c0b6c61b13$var$t_decode = $91b861c0b6c61b13$var$include.t_decode;
var $91b861c0b6c61b13$var$SocialNetworkSource_codec = $91b861c0b6c61b13$var$include.codec;
var $91b861c0b6c61b13$export$1daf4b0130eb169c = {
    fromJson: $91b861c0b6c61b13$var$fromJson,
    toJson: $91b861c0b6c61b13$var$toJson,
    t_encode: $91b861c0b6c61b13$var$t_encode,
    t_decode: $91b861c0b6c61b13$var$t_decode,
    codec: $91b861c0b6c61b13$var$SocialNetworkSource_codec
};
var $91b861c0b6c61b13$export$dff3ee56860fc5b9 = $91b861c0b6c61b13$var$t_encode;
var $91b861c0b6c61b13$export$9aaed70cd0774be8 = $91b861c0b6c61b13$var$t_decode;
 /* fromJson Not a pure module */ 
});
parcelRegister("j1laG", function(module, exports) {

$parcel$export(module.exports, "ContentType", function () { return $dd8e887b65296ed8$export$e2e108cbe2e4f865; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $dd8e887b65296ed8$var$videosPayload_decode = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "id", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "isPinned", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool)), function(id, isPinned) {
    return {
        id: $2whNH.getWithDefault(id, ""),
        isPinned: $2whNH.getWithDefault(isPinned, false)
    };
});
function $dd8e887b65296ed8$var$videosPayload_encode(payload) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(payload.id)
        ],
        [
            "isPinned",
            $AAkl8.bool(payload.isPinned)
        ]
    ]);
}
var $dd8e887b65296ed8$var$videosWithPayload_decode = $iv6Yc._3($jVmMx.Decode.map2, $jVmMx.Decode.exactVariantChoice("Videos"), $iv6Yc._2($jVmMx.Decode.index, 1, $dd8e887b65296ed8$var$videosPayload_decode), function(param, payload) {
    return /* Videos */ {
        _0: payload
    };
});
function $dd8e887b65296ed8$var$toJson(contentType) {
    return $jVmMx.Encode.deccoVariantWithPayload(contentType._0, "Videos", $dd8e887b65296ed8$var$videosPayload_encode);
}
var $dd8e887b65296ed8$var$include = $doJJK.Make({
    toJson: $dd8e887b65296ed8$var$toJson,
    fromJson: $dd8e887b65296ed8$var$videosWithPayload_decode
});
var $dd8e887b65296ed8$var$ContentType_t_encode = $dd8e887b65296ed8$var$include.t_encode;
var $dd8e887b65296ed8$var$ContentType_t_decode = $dd8e887b65296ed8$var$include.t_decode;
var $dd8e887b65296ed8$var$ContentType_codec = $dd8e887b65296ed8$var$include.codec;
var $dd8e887b65296ed8$export$e2e108cbe2e4f865 = {
    videosPayload_decode: $dd8e887b65296ed8$var$videosPayload_decode,
    videosPayload_encode: $dd8e887b65296ed8$var$videosPayload_encode,
    videosWithPayload_decode: $dd8e887b65296ed8$var$videosWithPayload_decode,
    fromJson: $dd8e887b65296ed8$var$videosWithPayload_decode,
    toJson: $dd8e887b65296ed8$var$toJson,
    t_encode: $dd8e887b65296ed8$var$ContentType_t_encode,
    t_decode: $dd8e887b65296ed8$var$ContentType_t_decode,
    codec: $dd8e887b65296ed8$var$ContentType_codec
};
 /* videosPayload_decode Not a pure module */ 
});

parcelRegister("eIysb", function(module, exports) {

$parcel$export(module.exports, "ContentType", function () { return $ab6fe6861e105328$export$e2e108cbe2e4f865; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $ab6fe6861e105328$var$reelsPayload_decode = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "id", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "isPinned", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "isSharedToFeed", $jVmMx.Decode.bool), $iv6Yc._2($jVmMx.Decode.field, "isScraped", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "isCollaborated", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool)), function(id, isPinned, isSharedToFeed, isScraped, isCollaborated) {
    return {
        id: $2whNH.getWithDefault(id, ""),
        isPinned: $2whNH.getWithDefault(isPinned, false),
        isSharedToFeed: isSharedToFeed,
        isScraped: $2whNH.getWithDefault(isScraped, false),
        isCollaborated: $2whNH.getWithDefault(isCollaborated, false)
    };
});
function $ab6fe6861e105328$var$reelsPayload_encode(payload) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(payload.id)
        ],
        [
            "isPinned",
            $AAkl8.bool(payload.isPinned)
        ],
        [
            "isSharedToFeed",
            $AAkl8.bool(payload.isSharedToFeed)
        ],
        [
            "isScraped",
            $AAkl8.bool(payload.isScraped)
        ],
        [
            "isCollaborated",
            $AAkl8.bool(payload.isCollaborated)
        ]
    ]);
}
var $ab6fe6861e105328$var$postsPayload_decode = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "isPinned", $jVmMx.Decode.bool), $iv6Yc._2($jVmMx.Decode.field, "isScraped", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "isCollaborated", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool)), function(id, isPinned, isScraped, isCollaborated) {
    return {
        id: $2whNH.getWithDefault(id, ""),
        isPinned: isPinned,
        isScraped: $2whNH.getWithDefault(isScraped, false),
        isCollaborated: $2whNH.getWithDefault(isCollaborated, false)
    };
});
function $ab6fe6861e105328$var$postsPayload_encode(payload) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(payload.id)
        ],
        [
            "isPinned",
            $AAkl8.bool(payload.isPinned)
        ],
        [
            "isScraped",
            $AAkl8.bool(payload.isScraped)
        ],
        [
            "isCollaborated",
            $AAkl8.bool(payload.isCollaborated)
        ]
    ]);
}
var $ab6fe6861e105328$var$reelsWithPayload_decode = $iv6Yc._3($jVmMx.Decode.map2, $jVmMx.Decode.exactVariantChoice("Reels"), $iv6Yc._2($jVmMx.Decode.index, 1, $ab6fe6861e105328$var$reelsPayload_decode), function(param, payload) {
    return {
        TAG: /* Reels */ 1,
        _0: payload
    };
});
var $ab6fe6861e105328$var$instagramContentType_v2_decode = $iv6Yc._2($jVmMx.Decode.oneOf, $iv6Yc._2($jVmMx.Decode.andThen, $jVmMx.Decode.exactVariantChoice("Posts"), function(param) {
    return $iv6Yc._1($jVmMx.Decode.succeed, {
        TAG: /* Posts */ 0,
        _0: {
            id: "",
            isPinned: false,
            isScraped: false,
            isCollaborated: false
        }
    });
}), [
    $ab6fe6861e105328$var$reelsWithPayload_decode
]);
var $ab6fe6861e105328$var$postsWithPayload_decode = $iv6Yc._3($jVmMx.Decode.map2, $jVmMx.Decode.exactVariantChoice("Posts"), $iv6Yc._2($jVmMx.Decode.index, 1, $ab6fe6861e105328$var$postsPayload_decode), function(param, payload) {
    return {
        TAG: /* Posts */ 0,
        _0: payload
    };
});
var $ab6fe6861e105328$var$instagramContentType_v1_decode = $iv6Yc._2($jVmMx.Decode.oneOf, $iv6Yc._2($jVmMx.Decode.andThen, $jVmMx.Decode.exactVariantChoice("Posts"), function(param) {
    return $iv6Yc._1($jVmMx.Decode.succeed, {
        TAG: /* Posts */ 0,
        _0: {
            id: "",
            isPinned: false,
            isScraped: false,
            isCollaborated: false
        }
    });
}), [
    $iv6Yc._2($jVmMx.Decode.andThen, $jVmMx.Decode.exactVariantChoice("Reels"), function(param) {
        return $iv6Yc._1($jVmMx.Decode.succeed, {
            TAG: /* Reels */ 1,
            _0: {
                id: "",
                isPinned: false,
                isSharedToFeed: true,
                isScraped: false,
                isCollaborated: false
            }
        });
    })
]);
var $ab6fe6861e105328$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $ab6fe6861e105328$var$postsWithPayload_decode, [
    $ab6fe6861e105328$var$reelsWithPayload_decode
]);
var $ab6fe6861e105328$var$fromJson$1 = $iv6Yc._2($jVmMx.Decode.oneOf, $ab6fe6861e105328$var$fromJson, [
    $ab6fe6861e105328$var$instagramContentType_v2_decode,
    $ab6fe6861e105328$var$instagramContentType_v1_decode
]);
function $ab6fe6861e105328$var$toJson(contentType) {
    if (contentType.TAG === /* Posts */ 0) return $jVmMx.Encode.deccoVariantWithPayload(contentType._0, "Posts", $ab6fe6861e105328$var$postsPayload_encode);
    else return $jVmMx.Encode.deccoVariantWithPayload(contentType._0, "Reels", $ab6fe6861e105328$var$reelsPayload_encode);
}
var $ab6fe6861e105328$var$include = $doJJK.Make({
    toJson: $ab6fe6861e105328$var$toJson,
    fromJson: $ab6fe6861e105328$var$fromJson$1
});
var $ab6fe6861e105328$var$ContentType_t_encode = $ab6fe6861e105328$var$include.t_encode;
var $ab6fe6861e105328$var$ContentType_t_decode = $ab6fe6861e105328$var$include.t_decode;
var $ab6fe6861e105328$var$ContentType_codec = $ab6fe6861e105328$var$include.codec;
var $ab6fe6861e105328$export$e2e108cbe2e4f865 = {
    reelsPayload_decode: $ab6fe6861e105328$var$reelsPayload_decode,
    reelsPayload_encode: $ab6fe6861e105328$var$reelsPayload_encode,
    postsPayload_decode: $ab6fe6861e105328$var$postsPayload_decode,
    postsPayload_encode: $ab6fe6861e105328$var$postsPayload_encode,
    reelsWithPayload_decode: $ab6fe6861e105328$var$reelsWithPayload_decode,
    instagramContentType_v2_decode: $ab6fe6861e105328$var$instagramContentType_v2_decode,
    postsWithPayload_decode: $ab6fe6861e105328$var$postsWithPayload_decode,
    instagramContentType_v1_decode: $ab6fe6861e105328$var$instagramContentType_v1_decode,
    fromJson: $ab6fe6861e105328$var$fromJson$1,
    toJson: $ab6fe6861e105328$var$toJson,
    t_encode: $ab6fe6861e105328$var$ContentType_t_encode,
    t_decode: $ab6fe6861e105328$var$ContentType_t_decode,
    codec: $ab6fe6861e105328$var$ContentType_codec
};
 /* reelsPayload_decode Not a pure module */ 
});


parcelRegister("5kJL4", function(module, exports) {

$parcel$export(module.exports, "gridColumns_fromJson", function () { return $3e2250a5077b1b2b$export$8c25ab61e3ebfea6; });
$parcel$export(module.exports, "layoutGap_fromJson", function () { return $3e2250a5077b1b2b$export$d1231c8849dff43d; });
$parcel$export(module.exports, "sliderEffect_fromJson", function () { return $3e2250a5077b1b2b$export$7b8c2d503c3f2b85; });
$parcel$export(module.exports, "sliderNav_fromJson", function () { return $3e2250a5077b1b2b$export$a97538abbb745701; });
$parcel$export(module.exports, "transition_fromJson", function () { return $3e2250a5077b1b2b$export$e325d0430234ce09; });
$parcel$export(module.exports, "smartbarCategoryLayout_fromJson", function () { return $3e2250a5077b1b2b$export$caa8cc636f063fc5; });
$parcel$export(module.exports, "smartbarCategorySize_fromJson", function () { return $3e2250a5077b1b2b$export$4b356bb189ad847c; });
$parcel$export(module.exports, "cardShape_fromJson", function () { return $3e2250a5077b1b2b$export$62374691ae503c00; });
$parcel$export(module.exports, "gridPayload_fromJson", function () { return $3e2250a5077b1b2b$export$f881733ee4dc8a30; });
$parcel$export(module.exports, "sliderPayload_fromJson", function () { return $3e2250a5077b1b2b$export$e419410b2a3ba3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $bkHbG = parcelRequire("bkHbG");
var $3e2250a5077b1b2b$export$8c25ab61e3ebfea6 = $jVmMx.Decode.simpleVariant([
    [
        "OneColumnGrid",
        /* OneColumnGrid */ 0
    ],
    [
        "TwoColumnGrid",
        /* TwoColumnGrid */ 1
    ],
    [
        "ThreeColumnGrid",
        /* ThreeColumnGrid */ 2
    ],
    [
        "FourColumnGrid",
        /* FourColumnGrid */ 3
    ],
    [
        "FiveColumnGrid",
        /* FiveColumnGrid */ 4
    ],
    [
        "SixColumnGrid",
        /* SixColumnGrid */ 5
    ],
    [
        "SevenColumnGrid",
        /* SevenColumnGrid */ 6
    ],
    [
        "EightColumnGrid",
        /* EightColumnGrid */ 7
    ],
    [
        "TwelveColumnGrid",
        /* TwelveColumnGrid */ 8
    ]
]);
var $3e2250a5077b1b2b$var$pixelDecoder = $jVmMx.Decode.deccoVariantWithPayload("Pixels", $jVmMx.Decode.$$int, function(i) {
    return /* Pixels */ {
        _0: i
    };
});
var $3e2250a5077b1b2b$export$d1231c8849dff43d = $iv6Yc._2($jVmMx.Decode.oneOf, $3e2250a5077b1b2b$var$pixelDecoder, [
    $jVmMx.Decode.simpleVariant([
        [
            "Equal",
            /* Equal */ 0
        ],
        [
            "Half",
            /* Half */ 1
        ],
        [
            "Double",
            /* Double */ 2
        ]
    ])
]);
var $3e2250a5077b1b2b$export$7b8c2d503c3f2b85 = $jVmMx.Decode.simpleVariant([
    [
        "EffectSlide",
        /* EffectSlide */ 0
    ],
    [
        "EffectFade",
        /* EffectFade */ 1
    ]
]);
var $3e2250a5077b1b2b$export$a97538abbb745701 = $jVmMx.Decode.simpleVariant([
    [
        "NavAuto",
        /* NavAuto */ 0
    ],
    [
        "NavArrows",
        /* NavArrows */ 1
    ],
    [
        "NavScrollbar",
        /* NavScrollbar */ 2
    ],
    [
        "NavDots",
        /* NavDots */ 3
    ],
    [
        "NavNone",
        /* NavNone */ 4
    ]
]);
var $3e2250a5077b1b2b$export$e325d0430234ce09 = $jVmMx.Decode.simpleVariant([
    [
        "TransitionEase",
        /* TransitionEase */ 0
    ],
    [
        "TransitionLinear",
        /* TransitionLinear */ 1
    ],
    [
        "TransitionEaseIn",
        /* TransitionEaseIn */ 2
    ],
    [
        "TransitionEaseOut",
        /* TransitionEaseOut */ 3
    ],
    [
        "TransitionEaseInOut",
        /* TransitionEaseInOut */ 4
    ]
]);
var $3e2250a5077b1b2b$var$iconsWithLabelDecoder = $jVmMx.Decode.deccoVariantWithPayload("IconsWithLabel", $iv6Yc._2($jVmMx.Decode.map, $iv6Yc._2($jVmMx.Decode.field, "lineClamp", $jVmMx.Decode.$$int), function(lineClamp) {
    return /* IconsWithLabel */ {
        lineClamp: lineClamp
    };
}), function(v) {
    return v;
});
var $3e2250a5077b1b2b$export$caa8cc636f063fc5 = $iv6Yc._2($jVmMx.Decode.oneOf, $3e2250a5077b1b2b$var$iconsWithLabelDecoder, [
    $jVmMx.Decode.simpleVariant([
        [
            "Labels",
            /* Labels */ 0
        ],
        [
            "IconsOnly",
            /* IconsOnly */ 1
        ],
        [
            "PillsWithLabel",
            /* PillsWithLabel */ 2
        ],
        [
            "PillsWithIcon",
            /* PillsWithIcon */ 3
        ],
        [
            "PillsWithRoundedIcon",
            /* PillsWithRoundedIcon */ 4
        ]
    ])
]);
var $3e2250a5077b1b2b$export$4b356bb189ad847c = $jVmMx.Decode.simpleVariant([
    [
        "Small",
        /* Small */ 0
    ],
    [
        "Medium",
        /* Medium */ 1
    ],
    [
        "Large",
        /* Large */ 2
    ]
]);
var $3e2250a5077b1b2b$var$customDecoder = $jVmMx.Decode.deccoVariantWithPayload("Custom", $iv6Yc._2($jVmMx.Decode.tuple2, $jVmMx.Decode.$$int, $jVmMx.Decode.$$int), function(param) {
    return /* Custom */ {
        _0: param[0],
        _1: param[1]
    };
});
var $3e2250a5077b1b2b$export$62374691ae503c00 = $iv6Yc._2($jVmMx.Decode.oneOf, $3e2250a5077b1b2b$var$customDecoder, [
    $jVmMx.Decode.simpleVariant([
        [
            "Circle",
            /* Circle */ 0
        ],
        [
            "Square",
            /* Square */ 1
        ],
        [
            "Landscape",
            /* Landscape */ 2
        ],
        [
            "Portrait",
            /* Portrait */ 3
        ],
        [
            "Panorama",
            /* Panorama */ 4
        ],
        [
            "Wide",
            /* Wide */ 5
        ],
        [
            "Tall",
            /* Tall */ 6
        ]
    ])
]);
var $3e2250a5077b1b2b$export$f881733ee4dc8a30 = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "columns", $3e2250a5077b1b2b$export$8c25ab61e3ebfea6), $jVmMx.Decode.fieldWithDefault("gap", $3e2250a5077b1b2b$export$d1231c8849dff43d, /* Equal */ 0), $jVmMx.Decode.fieldWithDefault("maxRows", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("maxWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("padding", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined), $jVmMx.Decode.fieldWithDefault("pattern", $iv6Yc._1($jVmMx.Decode.option, $bkHbG.Layout.GridPattern.fromJson), undefined), function(columns, gap, maxRows, maxWidth, padding, pattern) {
    return {
        columns: columns,
        gap: gap,
        maxRows: maxRows,
        maxWidth: maxWidth,
        padding: padding,
        pattern: pattern
    };
});
var $3e2250a5077b1b2b$export$e419410b2a3ba3bb = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(slidesPerView, gap, maxWidth, padding, rows, effect, nav, transition, transitionSpeed, autoplay, autoplayDelay, loop) {
    return {
        slidesPerView: slidesPerView,
        gap: gap,
        maxWidth: maxWidth,
        padding: padding,
        rows: rows,
        effect: effect,
        nav: nav,
        transition: transition,
        transitionSpeed: transitionSpeed,
        autoplay: autoplay,
        autoplayDelay: autoplayDelay,
        loop: loop
    };
}), $iv6Yc._2($jVmMx.Decode.field, "slidesPerView", $jVmMx.Decode.$$float)), $jVmMx.Decode.fieldWithDefault("gap", $3e2250a5077b1b2b$export$d1231c8849dff43d, /* Equal */ 0)), $jVmMx.Decode.fieldWithDefault("maxWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("padding", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int), undefined)), $jVmMx.Decode.fieldWithDefault("rows", $jVmMx.Decode.$$int, 1)), $jVmMx.Decode.fieldWithDefault("effect", $3e2250a5077b1b2b$export$7b8c2d503c3f2b85, /* EffectSlide */ 0)), $jVmMx.Decode.fieldWithDefault("nav", $3e2250a5077b1b2b$export$a97538abbb745701, /* NavAuto */ 0)), $jVmMx.Decode.fieldWithDefault("transition", $3e2250a5077b1b2b$export$e325d0430234ce09, /* TransitionEaseOut */ 3)), $jVmMx.Decode.fieldWithDefault("transitionSpeed", $jVmMx.Decode.$$int, 300)), $jVmMx.Decode.fieldWithDefault("autoplay", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("autoplayDelay", $jVmMx.Decode.$$int, 3000)), $jVmMx.Decode.fieldWithDefault("loop", $jVmMx.Decode.bool, false));
 /* gridColumns_fromJson Not a pure module */ 
});


parcelRegister("kNO66", function(module, exports) {

$parcel$export(module.exports, "PanelSize", function () { return $f24f3e94dd9d9c04$export$69e2902d2a3921ff; });
$parcel$export(module.exports, "PanelPosition", function () { return $f24f3e94dd9d9c04$export$a048ae1f0ae09c2c; });
$parcel$export(module.exports, "DesktopPDPLayout", function () { return $f24f3e94dd9d9c04$export$631e3c3b01fb1045; });
$parcel$export(module.exports, "TitleDescriptionPosition", function () { return $f24f3e94dd9d9c04$export$9a41294384f62a08; });
$parcel$export(module.exports, "GaVersion", function () { return $f24f3e94dd9d9c04$export$a65f4ba0b4d85314; });
$parcel$export(module.exports, "PDPCTAConfig", function () { return $f24f3e94dd9d9c04$export$d8c400e89f051a97; });
$parcel$export(module.exports, "fromJson", function () { return $f24f3e94dd9d9c04$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "empty", function () { return $f24f3e94dd9d9c04$export$6e22c362a0406a2c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $jVmMx = parcelRequire("jVmMx");

var $3Wlzc = parcelRequire("3Wlzc");

var $atDFT = parcelRequire("atDFT");

var $1Gpco = parcelRequire("1Gpco");

var $dRfYk = parcelRequire("dRfYk");

var $f1TVX = parcelRequire("f1TVX");

var $dT0m1 = parcelRequire("dT0m1");

var $crJlr = parcelRequire("crJlr");

var $7lqRw = parcelRequire("7lqRw");

var $eaePg = parcelRequire("eaePg");

var $ij6do = parcelRequire("ij6do");

var $5kJL4 = parcelRequire("5kJL4");
var $f24f3e94dd9d9c04$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Large",
        /* Large */ 0
    ],
    [
        "Medium",
        /* Medium */ 1
    ],
    [
        "Small",
        /* Small */ 2
    ],
    [
        "FullWidth",
        /* FullWidth */ 3
    ]
]);
var $f24f3e94dd9d9c04$export$69e2902d2a3921ff = {
    fromJson: $f24f3e94dd9d9c04$var$fromJson
};
var $f24f3e94dd9d9c04$var$fromJson$1 = $jVmMx.Decode.simpleVariant([
    [
        "Left",
        /* Left */ 0
    ],
    [
        "Right",
        /* Right */ 1
    ]
]);
var $f24f3e94dd9d9c04$export$a048ae1f0ae09c2c = {
    fromJson: $f24f3e94dd9d9c04$var$fromJson$1
};
var $f24f3e94dd9d9c04$var$fromJson$2 = $jVmMx.Decode.simpleVariant([
    [
        "Old",
        /* Old */ 0
    ],
    [
        "Horizontal",
        /* Horizontal */ 1
    ],
    [
        "Vertical",
        /* Vertical */ 2
    ]
]);
var $f24f3e94dd9d9c04$export$631e3c3b01fb1045 = {
    fromJson: $f24f3e94dd9d9c04$var$fromJson$2
};
var $f24f3e94dd9d9c04$var$fromJson$3 = $jVmMx.Decode.simpleVariant([
    [
        "Left",
        /* Left */ 0
    ],
    [
        "Center",
        /* Center */ 1
    ]
]);
var $f24f3e94dd9d9c04$export$9a41294384f62a08 = {
    fromJson: $f24f3e94dd9d9c04$var$fromJson$3
};
var $f24f3e94dd9d9c04$var$fromJson$4 = $jVmMx.Decode.simpleVariant([
    [
        "Ua",
        /* Ua */ 0
    ],
    [
        "Gtag",
        /* Gtag */ 1
    ]
]);
var $f24f3e94dd9d9c04$export$a65f4ba0b4d85314 = {
    fromJson: $f24f3e94dd9d9c04$var$fromJson$4
};
var $f24f3e94dd9d9c04$var$addToCartProps_fromJson = $79vie.map4($79vie.field("textColor", $79vie.string), $79vie.field("bgColor", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("confirmationMessage", $79vie.string), function(textColor, bgColor, label, confirmationMessage) {
    return {
        textColor: textColor,
        bgColor: bgColor,
        label: label,
        confirmationMessage: confirmationMessage
    };
});
var $f24f3e94dd9d9c04$var$customActionProps_fromJson = $iv6Yc._8($jVmMx.Decode.map7, $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "textColor", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "bgColor", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "label", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "confirmationMessage", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "onClickFn", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "renderFn", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), function(id, textColor, bgColor, label, confirmationMessage, onClickFn, renderFn) {
    return {
        id: id,
        textColor: textColor,
        bgColor: bgColor,
        label: label,
        confirmationMessage: confirmationMessage,
        onClickFn: onClickFn,
        renderFn: renderFn
    };
});
var $f24f3e94dd9d9c04$var$pdpCTAAction_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("CustomAction", $f24f3e94dd9d9c04$var$customActionProps_fromJson, function(payload) {
    return {
        TAG: /* CustomAction */ 2,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("AddToCart", $f24f3e94dd9d9c04$var$addToCartProps_fromJson, function(payload) {
        return {
            TAG: /* AddToCart */ 0,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("OpenLink", $jVmMx.Decode.string, function(payload) {
        return {
            TAG: /* OpenLink */ 1,
            _0: payload
        };
    })
]);
var $f24f3e94dd9d9c04$var$fromJson$5 = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "primary", $f24f3e94dd9d9c04$var$pdpCTAAction_fromJson), $iv6Yc._2($jVmMx.Decode.field, "secondary", $iv6Yc._1($jVmMx.Decode.option, $f24f3e94dd9d9c04$var$pdpCTAAction_fromJson)), $jVmMx.Decode.fieldWithDefault("tertiary", $iv6Yc._1($jVmMx.Decode.option, $f24f3e94dd9d9c04$var$pdpCTAAction_fromJson), undefined), function(primary, secondary, tertiary) {
    return {
        primary: primary,
        secondary: secondary,
        tertiary: tertiary
    };
});
var $f24f3e94dd9d9c04$export$d8c400e89f051a97 = {
    addToCartProps_fromJson: $f24f3e94dd9d9c04$var$addToCartProps_fromJson,
    customActionProps_fromJson: $f24f3e94dd9d9c04$var$customActionProps_fromJson,
    pdpCTAAction_fromJson: $f24f3e94dd9d9c04$var$pdpCTAAction_fromJson,
    fromJson: $f24f3e94dd9d9c04$var$fromJson$5
};
var $f24f3e94dd9d9c04$export$7ae2d2a8b28a8cb8 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(panelSize, panelPosition, backdrop, backdropBlur, backdropColor, categoryLayout, categorySize, nestedCategoryLayout, nestedCategorySize, checkoutLink, checkoutCustomAction, currencyPickerEnabled, gridDensityZoomEnabled, filtersEnabled, filtersLabelOrder, linksAsSidebar, sidebarDesktopDefault, sidebarMobileDefault, backButton, smartbarEnabled, zIndexInt, zIndex, categoryCardShape, categoryCardFitToContainer, categoryCardTitleLineTruncate, productCardTitleLineTruncate, productCardFitToContainer, productCardShape, productCardSize, productCardAddToCart, pdpCTAConfig, pdpAddToCartLabel, pdpAddToCartConfirmation, pdpPrimaryCustomAction, pdpSecondaryCustomAction, pdpTertiaryCustomAction, pdpGalleryCustomAction, pdpSizeGuide, pdpCTAButtons, pdpOpenLinkLabel, pdpCTAButtonBgColor, pdpCTAButtonTextColor, pdpGalleryBGBlur, pdpGalleryBGColor, pdpPricePrefixText, pdpPriceSuffixText, pdpPromoText, shipping, shippingShort, arrival, hideOutOfStock, videoLoop, videoAutoPlay, videoMute, videoControls, openLinkLabel, openLinkInNewTab, openProductLink, outOfStockLabel, indexNode, quickviewCarousel, quickviewAutoplay, quickviewPictureInPicture, siteHeaderCSSSelector, siteHeaderRespect, displayVariantBy, newMobilePDP, desktopPDPLayout, newMobilePDPCube, newMobilePDPCover, quantityPicker, mkrBio, cart, gaTrackingId, gaVersion, contextualL1s, contextualInline, contextualMenuDesktop, contextualMenuMobile, autoHideBottombar, expandVariantsInProductsListing, favoritesEnabled, historyEnabled, plpHistorySliderEnabled, plpTitleDescriptionEnabled, plpTitleDescriptionPosition, seoDynamicLinks, theme, pdpTheme, plpTheme, productCardComponent, pdpComponent) {
    return {
        panelSize: panelSize,
        panelPosition: panelPosition,
        backdrop: backdrop,
        backdropBlur: backdropBlur,
        backdropColor: backdropColor,
        categoryLayout: categoryLayout,
        categorySize: categorySize,
        nestedCategoryLayout: nestedCategoryLayout,
        nestedCategorySize: nestedCategorySize,
        checkoutLink: checkoutLink,
        checkoutCustomAction: checkoutCustomAction,
        currencyPickerEnabled: currencyPickerEnabled,
        gridDensityZoomEnabled: gridDensityZoomEnabled,
        filtersEnabled: filtersEnabled,
        filtersLabelOrder: filtersLabelOrder,
        linksAsSidebar: linksAsSidebar,
        sidebarDesktopDefault: sidebarDesktopDefault,
        sidebarMobileDefault: sidebarMobileDefault,
        backButton: backButton,
        smartbarEnabled: smartbarEnabled,
        zIndexInt: zIndexInt,
        zIndex: zIndex,
        categoryCardShape: categoryCardShape,
        categoryCardFitToContainer: categoryCardFitToContainer,
        categoryCardTitleLineTruncate: categoryCardTitleLineTruncate,
        productCardTitleLineTruncate: productCardTitleLineTruncate,
        productCardFitToContainer: productCardFitToContainer,
        productCardShape: productCardShape,
        productCardSize: productCardSize,
        productCardAddToCart: productCardAddToCart,
        pdpCTAConfig: pdpCTAConfig,
        pdpAddToCartLabel: pdpAddToCartLabel,
        pdpAddToCartConfirmation: pdpAddToCartConfirmation,
        pdpPrimaryCustomAction: pdpPrimaryCustomAction,
        pdpSecondaryCustomAction: pdpSecondaryCustomAction,
        pdpTertiaryCustomAction: pdpTertiaryCustomAction,
        pdpGalleryCustomAction: pdpGalleryCustomAction,
        pdpSizeGuide: pdpSizeGuide,
        pdpCTAButtons: pdpCTAButtons,
        pdpOpenLinkLabel: pdpOpenLinkLabel,
        pdpCTAButtonBgColor: pdpCTAButtonBgColor,
        pdpCTAButtonTextColor: pdpCTAButtonTextColor,
        pdpGalleryBGBlur: pdpGalleryBGBlur,
        pdpGalleryBGColor: pdpGalleryBGColor,
        pdpPricePrefixText: pdpPricePrefixText,
        pdpPriceSuffixText: pdpPriceSuffixText,
        pdpPromoText: pdpPromoText,
        shipping: shipping,
        shippingShort: shippingShort,
        arrival: arrival,
        hideOutOfStock: hideOutOfStock,
        videoLoop: videoLoop,
        videoAutoPlay: videoAutoPlay,
        videoMute: videoMute,
        videoControls: videoControls,
        openLinkLabel: openLinkLabel,
        openLinkInNewTab: openLinkInNewTab,
        openProductLink: openProductLink,
        outOfStockLabel: outOfStockLabel,
        indexNode: indexNode,
        quickviewCarousel: quickviewCarousel,
        quickviewAutoplay: quickviewAutoplay,
        quickviewPictureInPicture: quickviewPictureInPicture,
        siteHeaderCSSSelector: siteHeaderCSSSelector,
        siteHeaderRespect: siteHeaderRespect,
        displayVariantBy: displayVariantBy,
        newMobilePDP: newMobilePDP,
        desktopPDPLayout: desktopPDPLayout,
        newMobilePDPCube: newMobilePDPCube,
        newMobilePDPCover: newMobilePDPCover,
        quantityPicker: quantityPicker,
        mkrBio: mkrBio,
        cart: cart,
        gaTrackingId: gaTrackingId,
        gaVersion: gaVersion,
        contextualL1s: contextualL1s,
        contextualInline: contextualInline,
        contextualMenuDesktop: contextualMenuDesktop,
        contextualMenuMobile: contextualMenuMobile,
        autoHideBottombar: autoHideBottombar,
        expandVariantsInProductsListing: expandVariantsInProductsListing,
        favoritesEnabled: favoritesEnabled,
        historyEnabled: historyEnabled,
        plpHistorySliderEnabled: plpHistorySliderEnabled,
        plpTitleDescriptionEnabled: plpTitleDescriptionEnabled,
        plpTitleDescriptionPosition: plpTitleDescriptionPosition,
        seoDynamicLinks: seoDynamicLinks,
        theme: theme,
        plpTheme: plpTheme,
        pdpTheme: pdpTheme,
        productCardComponent: productCardComponent,
        pdpComponent: pdpComponent
    };
}), $iv6Yc._2($jVmMx.Decode.field, "panelSize", $f24f3e94dd9d9c04$var$fromJson)), $iv6Yc._2($jVmMx.Decode.field, "panelPosition", $f24f3e94dd9d9c04$var$fromJson$1)), $iv6Yc._2($jVmMx.Decode.field, "backdrop", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "backdropBlur", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "backdropColor", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "categoryLayout", $5kJL4.smartbarCategoryLayout_fromJson)), $iv6Yc._2($jVmMx.Decode.field, "categorySize", $5kJL4.smartbarCategorySize_fromJson)), $iv6Yc._2($jVmMx.Decode.field, "nestedCategoryLayout", $5kJL4.smartbarCategoryLayout_fromJson)), $iv6Yc._2($jVmMx.Decode.field, "nestedCategorySize", $5kJL4.smartbarCategorySize_fromJson)), $iv6Yc._2($jVmMx.Decode.field, "checkoutLink", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $jVmMx.Decode.fieldWithDefault("checkoutCustomAction", $iv6Yc._1($jVmMx.Decode.option, $dRfYk.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("currencyPickerEnabled", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("gridDensityZoomEnabled", $jVmMx.Decode.bool, false)), $iv6Yc._2($jVmMx.Decode.field, "filtersEnabled", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "filtersLabelOrder", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "linksAsSidebar", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "sidebarDesktopDefault", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "sidebarMobileDefault", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "backButton", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "smartbarEnabled", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "zIndexInt", $jVmMx.Decode.$$int)), $iv6Yc._2($jVmMx.Decode.field, "zIndex", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "categoryCardShape", $5kJL4.cardShape_fromJson)), $iv6Yc._2($jVmMx.Decode.field, "categoryCardFitToContainer", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "categoryCardTitleLineTruncate", $jVmMx.Decode.$$int)), $iv6Yc._2($jVmMx.Decode.field, "productCardTitleLineTruncate", $jVmMx.Decode.$$int)), $iv6Yc._2($jVmMx.Decode.field, "productCardFitToContainer", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "productCardShape", $5kJL4.cardShape_fromJson)), $iv6Yc._2($jVmMx.Decode.field, "productCardSize", $ij6do.CardSize.fromJson)), $iv6Yc._2($jVmMx.Decode.field, "productCardAddToCart", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "pdpCTAConfig", $f24f3e94dd9d9c04$var$fromJson$5)), $iv6Yc._2($jVmMx.Decode.field, "pdpAddToCartLabel", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "pdpAddToCartConfirmation", $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("pdpPrimaryCustomAction", $iv6Yc._1($jVmMx.Decode.option, $crJlr.Button.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("pdpSecondaryCustomAction", $iv6Yc._1($jVmMx.Decode.option, $crJlr.Button.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("pdpTertiaryCustomAction", $iv6Yc._1($jVmMx.Decode.option, $crJlr.Button.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("pdpGalleryCustomAction", $iv6Yc._1($jVmMx.Decode.option, $crJlr.Button.fromJson), undefined)), $iv6Yc._2($jVmMx.Decode.field, "pdpSizeGuide", $iv6Yc._1($jVmMx.Decode.option, $f1TVX.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "pdpCTAButtons", $dT0m1.fromJson)), $iv6Yc._2($jVmMx.Decode.field, "pdpOpenLinkLabel", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "pdpCTAButtonBgColor", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "pdpCTAButtonTextColor", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "pdpGalleryBGBlur", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "pdpGalleryBGColor", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "pdpPricePrefixText", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "pdpPriceSuffixText", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "pdpPromoText", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "shipping", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "shippingShort", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "arrival", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "hideOutOfStock", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "videoLoop", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "videoAutoPlay", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "videoMute", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "videoControls", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "openLinkLabel", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "openLinkInNewTab", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "openProductLink", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "outOfStockLabel", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "indexNode", $iv6Yc._1($jVmMx.Decode.option, $ij6do.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "quickviewCarousel", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "quickviewAutoplay", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "quickviewPictureInPicture", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "siteHeaderCSSSelector", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "siteHeaderRespect", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "displayVariantBy", $eaePg.fromJson)), $iv6Yc._2($jVmMx.Decode.field, "newMobilePDP", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "desktopPDPLayout", $f24f3e94dd9d9c04$var$fromJson$2)), $iv6Yc._2($jVmMx.Decode.field, "newMobilePDPCube", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "newMobilePDPCover", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "quantityPicker", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "mkrBio", $iv6Yc._1($jVmMx.Decode.option, $atDFT.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "cart", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "gaTrackingId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "gaVersion", $f24f3e94dd9d9c04$var$fromJson$4)), $iv6Yc._2($jVmMx.Decode.field, "contextualL1s", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "contextualInline", $jVmMx.Decode.bool)), $jVmMx.Decode.fieldWithDefault("contextualMenuDesktop", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("contextualMenuMobile", $jVmMx.Decode.bool, false)), $iv6Yc._2($jVmMx.Decode.field, "autoHideBottombar", $jVmMx.Decode.bool)), $iv6Yc._2($jVmMx.Decode.field, "expandVariantsInProductsListing", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool))), $jVmMx.Decode.fieldWithDefault("favoritesEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("historyEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("plpHistorySliderEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("plpTitleDescriptionEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("plpTitleDescriptionPosition", $f24f3e94dd9d9c04$var$fromJson$3, /* Left */ 0)), $jVmMx.Decode.fieldWithDefault("seoDynamicLinks", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("theme", $1Gpco.fromJson, $1Gpco.empty)), $jVmMx.Decode.fieldWithDefault("pdpTheme", $iv6Yc._1($jVmMx.Decode.option, $1Gpco.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("plpTheme", $iv6Yc._1($jVmMx.Decode.option, $1Gpco.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("productCardComponent", $iv6Yc._1($jVmMx.Decode.option, $7lqRw.reference_fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("pdpComponent", $iv6Yc._1($jVmMx.Decode.option, $7lqRw.reference_fromJson), undefined));
var $f24f3e94dd9d9c04$var$empty_filtersLabelOrder = [];
var $f24f3e94dd9d9c04$var$empty_pdpCTAConfig = {
    primary: {
        TAG: /* OpenLink */ 1,
        _0: "test"
    },
    secondary: undefined,
    tertiary: undefined
};
var $f24f3e94dd9d9c04$var$empty_pdpCTAButtons = [
    "open_link",
    undefined,
    undefined
];
var $f24f3e94dd9d9c04$var$empty_theme = {
    themeId: $iv6Yc._1($3Wlzc.fromString, "empty"),
    themeName: "",
    themeCreatedAt: 0,
    themeUpdatedAt: 0,
    primaryColor: "#111827",
    secondaryColor: "#374151",
    tertiaryColor: "#6B7280",
    accentColor: "#000000",
    backgroundColor: "#ffffff",
    backgroundArt: /* NoArt */ 0,
    placeholderColor: "#F3F4F6",
    productPromoBackgroundColor: "#F3F4F6",
    productPromoLabelColor: "#111827",
    productPriceDiscountBackgroundColor: "#dc2626",
    productPriceDiscountLabelColor: "#ffffff",
    drawerBackgroundColor: "#ffffff",
    drawerLabelColor: "#111827",
    headingFont: {
        fontFamily: undefined,
        fontSizeScale: 1.0,
        fontWeight: /* WeightAuto */ 0
    },
    bodyFont: {
        fontFamily: undefined,
        fontSizeScale: 1.0,
        fontWeight: /* WeightAuto */ 0
    },
    buttonFont: {
        fontFamily: undefined,
        fontSizeScale: 1.0,
        fontWeight: /* WeightAuto */ 0
    },
    roundedEdges: "4px",
    rowGutter: "45px",
    columnGutter: "12px",
    sectionVerticalPadding: "0px",
    sectionPaddingTop: undefined,
    sectionPaddingBottom: undefined
};
var $f24f3e94dd9d9c04$export$6e22c362a0406a2c = {
    panelSize: /* Small */ 2,
    panelPosition: /* Right */ 1,
    backdrop: true,
    backdropBlur: true,
    backdropColor: "",
    categoryLayout: /* Labels */ 0,
    categorySize: /* Small */ 0,
    nestedCategoryLayout: /* Labels */ 0,
    nestedCategorySize: /* Small */ 0,
    checkoutLink: undefined,
    checkoutCustomAction: undefined,
    currencyPickerEnabled: true,
    gridDensityZoomEnabled: true,
    filtersEnabled: true,
    filtersLabelOrder: $f24f3e94dd9d9c04$var$empty_filtersLabelOrder,
    linksAsSidebar: true,
    sidebarDesktopDefault: true,
    sidebarMobileDefault: true,
    backButton: true,
    smartbarEnabled: true,
    zIndexInt: 0,
    zIndex: "",
    categoryCardShape: /* Square */ 1,
    categoryCardFitToContainer: true,
    categoryCardTitleLineTruncate: 0,
    productCardTitleLineTruncate: 0,
    productCardFitToContainer: true,
    productCardShape: /* Square */ 1,
    productCardSize: /* Md */ 4,
    productCardAddToCart: true,
    pdpCTAConfig: $f24f3e94dd9d9c04$var$empty_pdpCTAConfig,
    pdpAddToCartLabel: "Add to cart",
    pdpAddToCartConfirmation: "",
    pdpPrimaryCustomAction: undefined,
    pdpSecondaryCustomAction: undefined,
    pdpTertiaryCustomAction: undefined,
    pdpGalleryCustomAction: undefined,
    pdpSizeGuide: undefined,
    pdpCTAButtons: $f24f3e94dd9d9c04$var$empty_pdpCTAButtons,
    pdpOpenLinkLabel: "",
    pdpCTAButtonBgColor: "",
    pdpCTAButtonTextColor: "",
    pdpGalleryBGBlur: true,
    pdpGalleryBGColor: "",
    pdpPricePrefixText: undefined,
    pdpPriceSuffixText: undefined,
    pdpPromoText: undefined,
    shipping: undefined,
    shippingShort: undefined,
    arrival: undefined,
    hideOutOfStock: true,
    videoLoop: true,
    videoAutoPlay: true,
    videoMute: true,
    videoControls: true,
    openLinkLabel: "",
    openLinkInNewTab: true,
    openProductLink: true,
    outOfStockLabel: "",
    indexNode: undefined,
    quickviewCarousel: true,
    quickviewAutoplay: true,
    quickviewPictureInPicture: true,
    siteHeaderCSSSelector: undefined,
    siteHeaderRespect: false,
    displayVariantBy: /* FirstVariant */ 0,
    newMobilePDP: false,
    desktopPDPLayout: /* Old */ 0,
    newMobilePDPCube: false,
    newMobilePDPCover: false,
    quantityPicker: false,
    mkrBio: undefined,
    cart: false,
    gaTrackingId: undefined,
    gaVersion: /* Gtag */ 1,
    contextualL1s: false,
    contextualInline: false,
    contextualMenuDesktop: false,
    contextualMenuMobile: false,
    autoHideBottombar: false,
    expandVariantsInProductsListing: undefined,
    favoritesEnabled: false,
    historyEnabled: false,
    plpHistorySliderEnabled: false,
    plpTitleDescriptionEnabled: false,
    plpTitleDescriptionPosition: /* Left */ 0,
    seoDynamicLinks: false,
    theme: $f24f3e94dd9d9c04$var$empty_theme,
    plpTheme: undefined,
    pdpTheme: undefined,
    productCardComponent: undefined,
    pdpComponent: undefined
};
var $f24f3e94dd9d9c04$export$ce5bcb86ca2bfc97;
 /* fromJson Not a pure module */ 
});
parcelRegister("atDFT", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $7a0b63647ce1033d$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $7a0b63647ce1033d$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $1cVsx = parcelRequire("1cVsx");

var $1Efib = parcelRequire("1Efib");

var $iIV46 = parcelRequire("iIV46");

var $4WJAy = parcelRequire("4WJAy");
function $7a0b63647ce1033d$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "logoUrl",
            $iv6Yc._1($jVmMx.Encode.string, param.logoUrl)
        ],
        [
            "name",
            $jVmMx.Encode.nullable(param.name, $jVmMx.Encode.string)
        ],
        [
            "description",
            $jVmMx.Encode.nullable(param.description, $jVmMx.Encode.string)
        ],
        [
            "callToAction",
            $jVmMx.Encode.nullable(param.callToAction, $1cVsx.CallToAction.toJson)
        ],
        [
            "socialNetworksLinks",
            $iv6Yc._2($jVmMx.Encode.array, param.socialNetworksLinks, $iIV46.SocialNetworkLink.toJson)
        ],
        [
            "socialNetworkConnections",
            $iv6Yc._2($jVmMx.Encode.array, param.socialNetworkConnections, $4WJAy.SocialNetworkConnection.toJson)
        ]
    ]);
}
var $7a0b63647ce1033d$export$7ae2d2a8b28a8cb8 = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "logoUrl", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "name", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "description", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "callToAction", $iv6Yc._1($jVmMx.Decode.option, $1cVsx.CallToAction.fromJson)), $jVmMx.Decode.fieldWithDefault("socialNetworksLinks", $iv6Yc._1($jVmMx.Decode.array, $iIV46.SocialNetworkLink.fromJson), []), $jVmMx.Decode.fieldWithDefault("socialNetworkConnections", $iv6Yc._1($jVmMx.Decode.array, $4WJAy.SocialNetworkConnection.fromJson), []), function(logoUrl, name, description, callToAction, socialNetworksLinks, socialNetworkConnections) {
    return {
        logoUrl: logoUrl,
        name: name,
        description: description,
        callToAction: callToAction,
        socialNetworksLinks: socialNetworksLinks,
        socialNetworkConnections: socialNetworkConnections
    };
});
var $7a0b63647ce1033d$var$include = $doJJK.Make({
    toJson: $7a0b63647ce1033d$export$d5b7a8bf56ee1fe2,
    fromJson: $7a0b63647ce1033d$export$7ae2d2a8b28a8cb8
});
var $7a0b63647ce1033d$export$9ac734aae7a92a2f = $1Efib.SocialNetwork;
var $7a0b63647ce1033d$export$e484e22f04591e42 = $1Efib.socialNetwork_encode;
var $7a0b63647ce1033d$export$f4ccf1f914f20b8b = $1Efib.socialNetwork_decode;
var $7a0b63647ce1033d$export$f623d33378fe95d9 = $4WJAy.SocialNetworkConnection;
var $7a0b63647ce1033d$export$476f111d50424bc5 = $4WJAy.socialNetworkConnection_encode;
var $7a0b63647ce1033d$export$3077b58d91da28a8 = $4WJAy.socialNetworkConnection_decode;
var $7a0b63647ce1033d$export$a264728fb17e7f22 = $iIV46.SocialNetworkLink;
var $7a0b63647ce1033d$export$9d7f48f48c6f19fc = $iIV46.socialNetworkLink_encode;
var $7a0b63647ce1033d$export$8f0f8cac64b2ba68 = $iIV46.socialNetworkLink_decode;
var $7a0b63647ce1033d$export$9438b36140854db6 = $1cVsx.CallToAction;
var $7a0b63647ce1033d$export$c95d60fac5ec910f = $1cVsx.callToAction_encode;
var $7a0b63647ce1033d$export$2c8cd572e69a9d0a = $1cVsx.callToAction_decode;
var $7a0b63647ce1033d$export$cc42ff7b6c615091 = $7a0b63647ce1033d$var$include.t_encode;
var $7a0b63647ce1033d$export$bb5e712207166a02 = $7a0b63647ce1033d$var$include.t_decode;
var $7a0b63647ce1033d$export$1c37c01eba8ed446 = $7a0b63647ce1033d$var$include.codec;
 /* fromJson Not a pure module */ 
});
parcelRegister("1cVsx", function(module, exports) {

$parcel$export(module.exports, "CallToAction", function () { return $0e137ba89e6c71c5$export$9438b36140854db6; });
$parcel$export(module.exports, "callToAction_encode", function () { return $0e137ba89e6c71c5$export$c95d60fac5ec910f; });
$parcel$export(module.exports, "callToAction_decode", function () { return $0e137ba89e6c71c5$export$2c8cd572e69a9d0a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $doJJK = parcelRequire("doJJK");
function $0e137ba89e6c71c5$var$toJson(param) {
    return $AAkl8.object([
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "url",
            $AAkl8.string(param.url)
        ]
    ]);
}
var $0e137ba89e6c71c5$var$fromJson = $79vie.map2($79vie.field("label", $79vie.string), $79vie.field("url", $79vie.string), function(label, url) {
    return {
        label: label,
        url: url
    };
});
var $0e137ba89e6c71c5$var$include = $doJJK.Make({
    toJson: $0e137ba89e6c71c5$var$toJson,
    fromJson: $0e137ba89e6c71c5$var$fromJson
});
var $0e137ba89e6c71c5$var$t_encode = $0e137ba89e6c71c5$var$include.t_encode;
var $0e137ba89e6c71c5$var$t_decode = $0e137ba89e6c71c5$var$include.t_decode;
var $0e137ba89e6c71c5$var$CallToAction_codec = $0e137ba89e6c71c5$var$include.codec;
var $0e137ba89e6c71c5$export$9438b36140854db6 = {
    toJson: $0e137ba89e6c71c5$var$toJson,
    fromJson: $0e137ba89e6c71c5$var$fromJson,
    t_encode: $0e137ba89e6c71c5$var$t_encode,
    t_decode: $0e137ba89e6c71c5$var$t_decode,
    codec: $0e137ba89e6c71c5$var$CallToAction_codec
};
var $0e137ba89e6c71c5$export$c95d60fac5ec910f = $0e137ba89e6c71c5$var$t_encode;
var $0e137ba89e6c71c5$export$2c8cd572e69a9d0a = $0e137ba89e6c71c5$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("1Efib", function(module, exports) {

$parcel$export(module.exports, "SocialNetwork", function () { return $1335639e2d357902$export$9ac734aae7a92a2f; });
$parcel$export(module.exports, "socialNetwork_encode", function () { return $1335639e2d357902$export$e484e22f04591e42; });
$parcel$export(module.exports, "socialNetwork_decode", function () { return $1335639e2d357902$export$f4ccf1f914f20b8b; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $1335639e2d357902$var$partial_arg = [
    [
        "Instagram",
        /* Instagram */ 0
    ],
    [
        "Tiktok",
        /* Tiktok */ 1
    ],
    [
        "Twitter",
        /* Twitter */ 2
    ],
    [
        "Facebook",
        /* Facebook */ 3
    ],
    [
        "Youtube",
        /* Youtube */ 4
    ]
];
function $1335639e2d357902$var$toJson(param) {
    return $jVmMx.Encode.simpleVariant($1335639e2d357902$var$partial_arg, param);
}
var $1335639e2d357902$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Instagram",
        /* Instagram */ 0
    ],
    [
        "Tiktok",
        /* Tiktok */ 1
    ],
    [
        "Twitter",
        /* Twitter */ 2
    ],
    [
        "Facebook",
        /* Facebook */ 3
    ],
    [
        "Youtube",
        /* Youtube */ 4
    ]
]);
var $1335639e2d357902$var$include = $doJJK.Make({
    toJson: $1335639e2d357902$var$toJson,
    fromJson: $1335639e2d357902$var$fromJson
});
var $1335639e2d357902$var$t_encode = $1335639e2d357902$var$include.t_encode;
var $1335639e2d357902$var$t_decode = $1335639e2d357902$var$include.t_decode;
var $1335639e2d357902$var$SocialNetwork_codec = $1335639e2d357902$var$include.codec;
var $1335639e2d357902$export$9ac734aae7a92a2f = {
    toJson: $1335639e2d357902$var$toJson,
    fromJson: $1335639e2d357902$var$fromJson,
    t_encode: $1335639e2d357902$var$t_encode,
    t_decode: $1335639e2d357902$var$t_decode,
    codec: $1335639e2d357902$var$SocialNetwork_codec
};
var $1335639e2d357902$export$e484e22f04591e42 = $1335639e2d357902$var$t_encode;
var $1335639e2d357902$export$f4ccf1f914f20b8b = $1335639e2d357902$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("iIV46", function(module, exports) {

$parcel$export(module.exports, "SocialNetworkLink", function () { return $da189a01c4e0e366$export$a264728fb17e7f22; });
$parcel$export(module.exports, "socialNetworkLink_encode", function () { return $da189a01c4e0e366$export$9d7f48f48c6f19fc; });
$parcel$export(module.exports, "socialNetworkLink_decode", function () { return $da189a01c4e0e366$export$8f0f8cac64b2ba68; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $da189a01c4e0e366$var$toJson(v) {
    switch(v.TAG | 0){
        case /* Instagram */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Instagram", $jVmMx.Encode.string);
        case /* Tiktok */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Tiktok", $jVmMx.Encode.string);
        case /* Twitter */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Twitter", $jVmMx.Encode.string);
        case /* Facebook */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Facebook", $jVmMx.Encode.string);
        case /* Youtube */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Youtube", $jVmMx.Encode.string);
    }
}
var $da189a01c4e0e366$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Instagram", $jVmMx.Decode.string, function(value) {
    return {
        TAG: /* Instagram */ 0,
        _0: value
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Tiktok", $jVmMx.Decode.string, function(value) {
        return {
            TAG: /* Tiktok */ 1,
            _0: value
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Twitter", $jVmMx.Decode.string, function(value) {
        return {
            TAG: /* Twitter */ 2,
            _0: value
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Facebook", $jVmMx.Decode.string, function(value) {
        return {
            TAG: /* Facebook */ 3,
            _0: value
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Youtube", $jVmMx.Decode.string, function(value) {
        return {
            TAG: /* Youtube */ 4,
            _0: value
        };
    })
]);
var $da189a01c4e0e366$var$include = $doJJK.Make({
    toJson: $da189a01c4e0e366$var$toJson,
    fromJson: $da189a01c4e0e366$var$fromJson
});
var $da189a01c4e0e366$var$t_encode = $da189a01c4e0e366$var$include.t_encode;
var $da189a01c4e0e366$var$t_decode = $da189a01c4e0e366$var$include.t_decode;
var $da189a01c4e0e366$var$SocialNetworkLink_codec = $da189a01c4e0e366$var$include.codec;
var $da189a01c4e0e366$export$a264728fb17e7f22 = {
    toJson: $da189a01c4e0e366$var$toJson,
    fromJson: $da189a01c4e0e366$var$fromJson,
    t_encode: $da189a01c4e0e366$var$t_encode,
    t_decode: $da189a01c4e0e366$var$t_decode,
    codec: $da189a01c4e0e366$var$SocialNetworkLink_codec
};
var $da189a01c4e0e366$export$9d7f48f48c6f19fc = $da189a01c4e0e366$var$t_encode;
var $da189a01c4e0e366$export$8f0f8cac64b2ba68 = $da189a01c4e0e366$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("4WJAy", function(module, exports) {

$parcel$export(module.exports, "SocialNetworkConnection", function () { return $399ff121f23a86ed$export$f623d33378fe95d9; });
$parcel$export(module.exports, "socialNetworkConnection_encode", function () { return $399ff121f23a86ed$export$476f111d50424bc5; });
$parcel$export(module.exports, "socialNetworkConnection_decode", function () { return $399ff121f23a86ed$export$3077b58d91da28a8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $doJJK = parcelRequire("doJJK");

var $1Efib = parcelRequire("1Efib");
function $399ff121f23a86ed$var$toJson(param) {
    return $AAkl8.object([
        [
            "handle",
            $AAkl8.string(param.handle)
        ],
        [
            "showPostDescription",
            $AAkl8.bool(param.showPostDescription)
        ],
        [
            "showLikes",
            $AAkl8.bool(param.showLikes)
        ],
        [
            "showViews",
            $AAkl8.bool(param.showViews)
        ],
        [
            "numOfPosts",
            $AAkl8.$$int(param.numOfPosts)
        ],
        [
            "socialNetwork",
            $iv6Yc._1($1Efib.SocialNetwork.toJson, param.socialNetwork)
        ]
    ]);
}
var $399ff121f23a86ed$var$fromJson = $79vie.map6($79vie.field("handle", $79vie.string), $79vie.field("showPostDescription", $79vie.bool), $79vie.field("showLikes", $79vie.bool), $79vie.field("showViews", $79vie.bool), $79vie.field("numOfPosts", $79vie.$$int), $79vie.field("socialNetwork", $1Efib.SocialNetwork.fromJson), function(handle, showPostDescription, showLikes, showViews, numOfPosts, socialNetwork) {
    return {
        handle: handle,
        showPostDescription: showPostDescription,
        showLikes: showLikes,
        showViews: showViews,
        numOfPosts: numOfPosts,
        socialNetwork: socialNetwork
    };
});
var $399ff121f23a86ed$var$include = $doJJK.Make({
    toJson: $399ff121f23a86ed$var$toJson,
    fromJson: $399ff121f23a86ed$var$fromJson
});
var $399ff121f23a86ed$var$t_encode = $399ff121f23a86ed$var$include.t_encode;
var $399ff121f23a86ed$var$t_decode = $399ff121f23a86ed$var$include.t_decode;
var $399ff121f23a86ed$var$SocialNetworkConnection_codec = $399ff121f23a86ed$var$include.codec;
var $399ff121f23a86ed$export$f623d33378fe95d9 = {
    toJson: $399ff121f23a86ed$var$toJson,
    fromJson: $399ff121f23a86ed$var$fromJson,
    t_encode: $399ff121f23a86ed$var$t_encode,
    t_decode: $399ff121f23a86ed$var$t_decode,
    codec: $399ff121f23a86ed$var$SocialNetworkConnection_codec
};
var $399ff121f23a86ed$export$476f111d50424bc5 = $399ff121f23a86ed$var$t_encode;
var $399ff121f23a86ed$export$3077b58d91da28a8 = $399ff121f23a86ed$var$t_decode;
 /* fromJson Not a pure module */ 
});


parcelRegister("f1TVX", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $af12564938624f73$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $af12564938624f73$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2whNH = parcelRequire("2whNH");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $dRfYk = parcelRequire("dRfYk");
function $af12564938624f73$export$3e4db5ef97444133(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "disable",
            $iv6Yc._1($jVmMx.Encode.bool, param.disable)
        ],
        [
            "image",
            $jVmMx.Encode.nullable(param.image, $jVmMx.Encode.string)
        ],
        [
            "smallImage",
            $jVmMx.Encode.nullable(param.smallImage, $jVmMx.Encode.string)
        ],
        [
            "link",
            $jVmMx.Encode.nullable(param.link, $jVmMx.Encode.string)
        ],
        [
            "customScript",
            $jVmMx.Encode.nullable(param.customScript, $jVmMx.Encode.string)
        ],
        [
            "customAction",
            $jVmMx.Encode.nullable(param.customAction, $dRfYk.toJson)
        ]
    ]);
}
var $af12564938624f73$export$236903ff01f632a8 = $iv6Yc._7($jVmMx.Decode.map6, $jVmMx.Decode.fieldWithDefault("disable", $jVmMx.Decode.bool, false), $iv6Yc._2($jVmMx.Decode.field, "image", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "smallImage", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "link", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "customScript", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "customAction", $iv6Yc._1($jVmMx.Decode.option, $dRfYk.fromJson)), function(disable, image, smallImage, link, customScript, customAction) {
    return {
        disable: disable,
        image: image,
        smallImage: smallImage,
        link: link,
        customScript: customScript,
        customAction: customAction
    };
});
function $af12564938624f73$export$d5b7a8bf56ee1fe2(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "label",
            $iv6Yc._1($jVmMx.Encode.string, param.label)
        ],
        [
            "image",
            $jVmMx.Encode.nullable(param.image, $jVmMx.Encode.string)
        ],
        [
            "smallImage",
            $jVmMx.Encode.nullable(param.smallImage, $jVmMx.Encode.string)
        ],
        [
            "link",
            $jVmMx.Encode.nullable(param.link, $jVmMx.Encode.string)
        ],
        [
            "overrides",
            $jVmMx.Encode.nullable(param.overrides, function(__x) {
                return $jVmMx.Encode.dictWithEncoder(__x, $af12564938624f73$export$3e4db5ef97444133);
            })
        ],
        [
            "excludeCategoryIds",
            $iv6Yc._2($jVmMx.Encode.array, param.excludeCategoryIds, $jVmMx.Encode.string)
        ],
        [
            "customScript",
            $jVmMx.Encode.nullable(param.customScript, $jVmMx.Encode.string)
        ],
        [
            "customAction",
            $jVmMx.Encode.nullable(param.customAction, $dRfYk.toJson)
        ]
    ]);
}
var $af12564938624f73$export$7ae2d2a8b28a8cb8 = $iv6Yc.app($jVmMx.Decode.map8, [
    $jVmMx.Decode.fieldWithDefault("label", $jVmMx.Decode.string, "Size Guide"),
    $iv6Yc._2($jVmMx.Decode.field, "image", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)),
    $iv6Yc._2($jVmMx.Decode.field, "smallImage", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)),
    $iv6Yc._2($jVmMx.Decode.field, "link", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)),
    $iv6Yc._2($jVmMx.Decode.field, "overrides", $iv6Yc._1($jVmMx.Decode.option, $iv6Yc._1($jVmMx.Decode.dict, $af12564938624f73$export$236903ff01f632a8))),
    $jVmMx.Decode.fieldWithDefault("excludeCategoryIds", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.string), []),
    $iv6Yc._2($jVmMx.Decode.field, "customScript", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)),
    $iv6Yc._2($jVmMx.Decode.field, "customAction", $iv6Yc._1($jVmMx.Decode.option, $dRfYk.fromJson)),
    function(label, image, smallImage, link, overrides, excludeCategoryIds, customScript, customAction) {
        return {
            label: label,
            image: image,
            smallImage: smallImage,
            link: link,
            overrides: overrides,
            excludeCategoryIds: excludeCategoryIds,
            customScript: customScript,
            customAction: customAction
        };
    }
]);
var $af12564938624f73$var$empty_excludeCategoryIds = [];
var $af12564938624f73$export$6e22c362a0406a2c = {
    label: "Size Guide",
    image: undefined,
    smallImage: undefined,
    link: undefined,
    overrides: undefined,
    excludeCategoryIds: $af12564938624f73$var$empty_excludeCategoryIds,
    customScript: undefined,
    customAction: undefined
};
function $af12564938624f73$export$8dcf39a7a23517d9(t) {
    var disable = $2whNH.isNone(t.image) && $2whNH.isNone(t.smallImage) && $2whNH.isNone(t.link);
    return {
        disable: disable,
        image: t.image,
        smallImage: t.smallImage,
        link: t.link,
        customScript: t.customScript,
        customAction: t.customAction
    };
}
function $af12564938624f73$export$a07654da0f40bacb(templateOpt, subset) {
    var template = templateOpt !== undefined ? templateOpt : $af12564938624f73$export$6e22c362a0406a2c;
    return {
        label: template.label,
        image: subset.image,
        smallImage: subset.smallImage,
        link: subset.link,
        overrides: template.overrides,
        excludeCategoryIds: template.excludeCategoryIds,
        customScript: subset.customScript,
        customAction: subset.customAction
    };
}
var $af12564938624f73$var$include = $doJJK.Make({
    toJson: $af12564938624f73$export$d5b7a8bf56ee1fe2,
    fromJson: $af12564938624f73$export$7ae2d2a8b28a8cb8
});
var $af12564938624f73$export$668a436e0b5aab94 = {
    disable: false,
    image: undefined,
    smallImage: undefined,
    link: undefined,
    customScript: undefined,
    customAction: undefined
};
var $af12564938624f73$export$cc42ff7b6c615091 = $af12564938624f73$var$include.t_encode;
var $af12564938624f73$export$bb5e712207166a02 = $af12564938624f73$var$include.t_decode;
var $af12564938624f73$export$1c37c01eba8ed446 = $af12564938624f73$var$include.codec;
 /* subset_decode Not a pure module */ 
});

parcelRegister("dT0m1", function(module, exports) {

$parcel$export(module.exports, "fromJson", function () { return $a1c0afc6a41cf2ea$export$7ae2d2a8b28a8cb8; });
$parcel$export(module.exports, "toJson", function () { return $a1c0afc6a41cf2ea$export$d5b7a8bf56ee1fe2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $i7mYY = parcelRequire("i7mYY");

var $79vie = parcelRequire("79vie");

var $5oEIZ = parcelRequire("5oEIZ");

var $doJJK = parcelRequire("doJJK");
var $a1c0afc6a41cf2ea$export$7ae2d2a8b28a8cb8 = $79vie.andThen($79vie.string, function(str) {
    var parts = $i7mYY.keepMap(str.split($5oEIZ.separator), function(part) {
        switch(part){
            case "add_to_cart":
                return "add_to_cart";
            case "custom_action":
                return "custom_action";
            case "open_link":
                return "open_link";
            default:
                return;
        }
    });
    var match = $i7mYY.get(parts, 0);
    var match$1 = $i7mYY.get(parts, 1);
    var match$2 = $i7mYY.get(parts, 2);
    if (match !== undefined) {
        if (match$1 !== undefined) return $79vie.succeed([
            match$1,
            match,
            match$2
        ]);
        else if (match$2 !== undefined) return $79vie.fail("CTAButtons '" + str + "' is not supported.");
        else return $79vie.succeed([
            match,
            undefined,
            undefined
        ]);
    } else return $79vie.fail("CTAButtons '" + str + "' is not supported.");
});
var $a1c0afc6a41cf2ea$var$include = $doJJK.Make({
    toJson: $5oEIZ.t_encode,
    fromJson: $a1c0afc6a41cf2ea$export$7ae2d2a8b28a8cb8
});
var $a1c0afc6a41cf2ea$export$d5b7a8bf56ee1fe2 = $5oEIZ.t_encode;
var $a1c0afc6a41cf2ea$export$cc42ff7b6c615091 = $a1c0afc6a41cf2ea$var$include.t_encode;
var $a1c0afc6a41cf2ea$export$bb5e712207166a02 = $a1c0afc6a41cf2ea$var$include.t_decode;
var $a1c0afc6a41cf2ea$export$1c37c01eba8ed446 = $a1c0afc6a41cf2ea$var$include.codec;
 /* fromJson Not a pure module */ 
});
parcelRegister("5oEIZ", function(module, exports) {

$parcel$export(module.exports, "separator", function () { return $3edec8b28ff099de$export$3e523c77c1f23f8c; });
$parcel$export(module.exports, "t_encode", function () { return $3edec8b28ff099de$export$cc42ff7b6c615091; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $3zjNo = parcelRequire("3zjNo");

var $1ArWc = parcelRequire("1ArWc");

var $i7mYY = parcelRequire("i7mYY");
var $3edec8b28ff099de$export$3e523c77c1f23f8c = " + ";
function $3edec8b28ff099de$export$cc42ff7b6c615091(input) {
    var secondary = input[1];
    var primary = input[0];
    if (secondary !== undefined) {
        var tertiary = input[2];
        if (tertiary !== undefined) return secondary + $3edec8b28ff099de$export$3e523c77c1f23f8c + primary + $3edec8b28ff099de$export$3e523c77c1f23f8c + tertiary;
        else return secondary + $3edec8b28ff099de$export$3e523c77c1f23f8c + primary;
    }
    var secondary$1 = input[2];
    if (secondary$1 !== undefined) return secondary$1 + $3edec8b28ff099de$export$3e523c77c1f23f8c + primary;
    else return primary;
}
function $3edec8b28ff099de$export$bb5e712207166a02(json) {
    var str = $1ArWc.classify(json);
    if (typeof str === "number") return $3zjNo.error(undefined, "Trying to decode a field that is not a string to CTAButtons", json);
    if (str.TAG !== /* JSONString */ 0) return $3zjNo.error(undefined, "Trying to decode a field that is not a string to CTAButtons", json);
    var str$1 = str._0;
    var parts = $i7mYY.keepMap(str$1.split($3edec8b28ff099de$export$3e523c77c1f23f8c), function(part) {
        switch(part){
            case "add_to_cart":
                return "add_to_cart";
            case "custom_action":
                return "custom_action";
            case "open_link":
                return "open_link";
            default:
                return;
        }
    });
    var match = $i7mYY.get(parts, 0);
    var match$1 = $i7mYY.get(parts, 1);
    var match$2 = $i7mYY.get(parts, 2);
    if (match !== undefined) {
        if (match$1 !== undefined) return {
            TAG: /* Ok */ 0,
            _0: [
                match$1,
                match,
                match$2
            ]
        };
        if (match$2 === undefined) return {
            TAG: /* Ok */ 0,
            _0: [
                match,
                undefined,
                undefined
            ]
        };
    }
    return $3zjNo.error(undefined, "CTAButtons '" + str$1 + "' is not supported.", json);
}
 /* No side effect */ 
});


parcelRegister("eaePg", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $a4fd7ff2ead7aa09$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $a4fd7ff2ead7aa09$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $a4fd7ff2ead7aa09$var$partial_arg = [
    [
        "FirstVariant",
        /* FirstVariant */ 0
    ],
    [
        "HighestPriceVariant",
        /* HighestPriceVariant */ 1
    ],
    [
        "LowestPriceVariant",
        /* LowestPriceVariant */ 2
    ],
    [
        "HighestDiscountVariant",
        /* HighestDiscountVariant */ 3
    ]
];
function $a4fd7ff2ead7aa09$export$d5b7a8bf56ee1fe2(param) {
    return $jVmMx.Encode.simpleVariant($a4fd7ff2ead7aa09$var$partial_arg, param);
}
var $a4fd7ff2ead7aa09$export$7ae2d2a8b28a8cb8 = $jVmMx.Decode.simpleVariant([
    [
        "FirstVariant",
        /* FirstVariant */ 0
    ],
    [
        "HighestPriceVariant",
        /* HighestPriceVariant */ 1
    ],
    [
        "LowestPriceVariant",
        /* LowestPriceVariant */ 2
    ],
    [
        "HighestDiscountVariant",
        /* HighestDiscountVariant */ 3
    ]
]);
var $a4fd7ff2ead7aa09$var$include = $doJJK.Make({
    toJson: $a4fd7ff2ead7aa09$export$d5b7a8bf56ee1fe2,
    fromJson: $a4fd7ff2ead7aa09$export$7ae2d2a8b28a8cb8
});
var $a4fd7ff2ead7aa09$export$cc42ff7b6c615091 = $a4fd7ff2ead7aa09$var$include.t_encode;
var $a4fd7ff2ead7aa09$export$bb5e712207166a02 = $a4fd7ff2ead7aa09$var$include.t_decode;
var $a4fd7ff2ead7aa09$export$1c37c01eba8ed446 = $a4fd7ff2ead7aa09$var$include.codec;
 /* fromJson Not a pure module */ 
});


})();
//# sourceMappingURL=ConfigurationDecoder.bs.eb3c4f47.js.map
